/* eslint-disable */
import { getUploadLivraisonErrorMessage } from "../../../utils/uploadLivraisonError";
import { useTranslation as useUiTranslation } from "react-i18next";
import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  setDoc,
  doc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  writeBatch,
} from "firebase/firestore";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { db } from "../../../firebase";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Form from "react-bootstrap/Form";
import usePagination from "../../helper/paginate/Pagination";
import "./DataTableDemo.css";
import { Link, useNavigate } from "react-router-dom";
import { ComponentToPrint } from "./ComponentToPrint";
import { useReactToPrint } from "react-to-print";
import { useDispatch, useSelector } from "react-redux";
import { CSVLink } from "react-csv";
import { fetchDate } from "../../../utils/globleFunc";
import Swal from "sweetalert2";
import axios from "axios";
import moment from "moment";
import "moment/locale/ar"; // استيراد اللغة العربية
import "moment/locale/fr"; // استيراد اللغة الفرنسية
import apicache from "../../../components/clearCach/clear";
import { PDFDocument } from "pdf-lib";
import html2pdf from "html2pdf.js";
import { Menu, Dropdown, message, Input } from "antd";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Edit } from "lucide-react";
import useIsDark from "../../../utils/isDark";
import DeskModal from "./DeskModal";
import { GoogleSheetButtons } from "./googleSheetButton";
import PhoneActionMenu from "../../PhoneActionMenu";
import { changeShip as runChangeShip } from "./changeShip";
import { fetchAccount } from "../../../redux/account/account";
import { fetchOrders } from "../../../redux/orders/orders";
import { updateProduct } from "../../../redux/products/products";
import { consumeSubscriptionToken } from "../../../utils/subscriptionPayment";
import { decreaseOrderProductsStock } from "../utils/decreaseOrderProductsStock";
import AudioAffichage from "../AudioAffichage/AudioAffichage";

// order exporting app depends on delivery companies
import { ALGERIAN_SHIPPING_COMPANIES } from "../../../constants/algerian_shipping_companies";
import { exportOrdersByCompany } from "./exportByCompany";
import guepexCommunes from "../../../utils/data_livraison/data_guepex.json";

import { DHD_PLATFORM_URL } from "../../DhdCurrentPlanBanner";

const TrackshipCell = ({ data, isLocked }) => {
  const { t: uiT } = useUiTranslation();
  const [showPopup, setShowPopup] = useState(false);
  const buttonImage = "https://cdn-icons-png.flaticon.com/512/609/609361.png";

  const handlePopup = (visible) => (event) => {
    event.preventDefault();
    setShowPopup(visible);
  };

  return (
    <div className="relative">
      {isLocked ? (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>{uiT("ship.send_tracking_link")}</Tooltip>}
        >
          <button
            className="flex dark:!bg-[#181919] dark:!border-[#3c3a3d] items-center justify-center py-2.5 border rounded-lg hover:bg-[#faf1ff] transition-colors active:bg-[#faf1ff] bot mx-auto"
            disabled
          >
            <img
              src={buttonImage}
              style={{ width: "20px" }}
              alt={uiT("ui.buttonIcon")}
            />
          </button>
        </OverlayTrigger>
      ) : (
        <button
          className="flex items-center dark:!bg-[#181919] dark:!border-[#3c3a3d] justify-center py-2.5 border rounded-lg hover:bg-[#faf1ff] transition-colors active:bg-[#faf1ff] bot mx-auto"
          onMouseEnter={handlePopup(true)}
          onMouseLeave={handlePopup(false)}
        >
          <img
            src={buttonImage}
            style={{ width: "20px" }}
            alt={uiT("ui.buttonIcon")}
          />
        </button>
      )}

      {showPopup && (
        <div className="absolute z-10 p-2 mt-1 text-sm bg-white border rounded-lg -right-4">
          {data.tracking_status ? (
            <p>
              {data.tracking_status[data.tracking_status.length - 1].status}
            </p>
          ) : (
            <p>{uiT("ship.no_tracking_number")}</p>
          )}
        </div>
      )}
    </div>
  );
};
import { DHD_PLAN_NAME } from "../../DhdCurrentPlanBanner";
import {
  printDhdBordereaux,
  isDhdOrder,
} from "../../../utils/printDhdBordereaux";

const DataTableTemplatingDemo = ({
  filter,
  orders,
  pageSize,
  setData,
  setLgShow,
  confirmers = [],
  selectedConfirmer = "",
  onStatusChange = () => {},
  onDelete = () => {},
}) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const productss = useSelector((state) => state.ProductsReducer);
  const account = useSelector((state) => state.AccountReducer);
  const isDhdUser =
    account?.subscription?.plan === DHD_PLAN_NAME &&
    account?.subscription?.dhdPartnershipActive === true;

  const [isPrintingBordereaux, setIsPrintingBordereaux] = useState(false);
  const ordersState = useSelector((state) => state.OrdersReducer || []);
  const store = useSelector((state) => state.StoreReducer);

  // ask for desktop
  const [exportDeskQueue, setExportDeskQueue] = useState([]); // orders needing desk
  const [exportPendingOrders, setExportPendingOrders] = useState(null); // full selection waiting export
  const [exportDeskModalOpen, setExportDeskModalOpen] = useState(false);
  const [exportCurrentOrder, setExportCurrentOrder] = useState(null);
  const exportDeskCodesRef = useRef({});
  const exportPendingOrdersRef = useRef(null);
  const exportDeskQueueRef = useRef([]);
  const exportCurrentOrderRef = useRef(null);
  const [exportDeskModalKey, setExportDeskModalKey] = useState(0);
  const isAdvancingExportDeskQueueRef = useRef(false);

  const isStopdeskOrder = (o) =>
    o.stopdeskDelivery === true ||
    o.stopdeskDelivery === 1 ||
    o.stopdeskDelivery === "1" ||
    o.stopdeskDelivery === "true";

  const hasDeskCode = (o) =>
    !!(o.selectedDesk || o.ecomStopdeskCode || o.stopdeskCode);

  // list of linked delivery companies for order exporting
  const linkedDeliveryCompanies = ALGERIAN_SHIPPING_COMPANIES.filter(
    (c) =>
      c.key !== "other" &&
      c.supportsOrderExporting === true &&
      Array.isArray(store?.orderExportingCompanies) &&
      store.orderExportingCompanies.includes(c.key),
  );

  // exporting app is enabled!!
  const isOrderExportingEnabled =
    store?.orderExportingEnabled === true ||
    store?.orderExportingEnabled === "true";

  // zr export hub selection
  const [exportZrHubQueue, setExportZrHubQueue] = useState([]);
  const [exportZrPendingOrders, setExportZrPendingOrders] = useState(null);
  const [exportZrHubModalOpen, setExportZrHubModalOpen] = useState(false);
  const [exportZrCurrentOrder, setExportZrCurrentOrder] = useState(null);
  const exportZrHubNamesRef = useRef({});
  const exportZrPendingOrdersRef = useRef(null);
  const exportZrHubQueueRef = useRef([]);
  const exportZrCurrentOrderRef = useRef(null);

  const hasZrHub = (o) =>
    !!(o.selectedDesk || o.stopdeskName || o.zrExpressSelectedHub);

  const handleExportByCompany = async (companyKey) => {
    if (!selectedProducts.length) {
      Swal.fire({
        icon: "warning",
        title: t("ui.noSelectedOrders"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      return;
    }

    // zr express company
    if (companyKey === "zrexpress") {
      const needHub = selectedProducts.filter(
        (o) => isStopdeskOrder(o) && !hasZrHub(o),
      );

      if (needHub.length === 0) {
        try {
          await exportOrdersByCompany("zrexpress", selectedProducts);
        } catch (err) {
          console.error(err);
          Swal.fire({
            icon: "error",
            title: t("ui.exportFailed"),
            text: err.message || t("ui.exportError"),
            confirmButtonColor: "rgb(141, 93, 167)",
          });
        }
        return;
      }

      // open hub selection queue
      setExportZrPendingOrders(selectedProducts);
      exportZrHubNamesRef.current = {};
      setExportZrHubQueue(needHub);
      setExportZrCurrentOrder(needHub[0]);
      setExportZrHubModalOpen(true);
      return;
    }

    // ecom delivery company
    if (companyKey === "ecomdelivery") {
      const needDesk = selectedProducts.filter(
        (o) => isStopdeskOrder(o) && !hasDeskCode(o),
      );

      if (needDesk.length === 0) {
        try {
          await exportOrdersByCompany("ecomdelivery", selectedProducts);
        } catch (err) {
          console.error(err);
          Swal.fire({
            icon: "error",
            title: t("ui.exportFailed"),
            text: err.message || t("ui.exportError"),
            confirmButtonColor: "rgb(141, 93, 167)",
          });
        }
        return;
      }

      setExportPendingOrders(selectedProducts);
      exportPendingOrdersRef.current = selectedProducts;

      exportDeskCodesRef.current = {};
      exportDeskQueueRef.current = needDesk;
      setExportDeskQueue(needDesk);

      exportCurrentOrderRef.current = needDesk[0];
      setExportCurrentOrder(needDesk[0]);
      setExportDeskModalKey((k) => k + 1);
      setExportDeskModalOpen(true);
      return;
    }

    if (companyKey === "guepex") {
      const wilayaOptions = [
        ...new Set(guepexCommunes.map((c) => c.wilaya_name).filter(Boolean)),
      ].sort((a, b) => a.localeCompare(b));

      const { value: formValues } = await Swal.fire({
        title: t("ui.exportGuepex"),
        html: `
      <div style="text-align:right; direction:rtl; padding: 4px 0;">
        <div style="margin-bottom: 18px;">
          <label style="display:block; margin-bottom:8px; font-weight:600; color:#374151; font-size:14px;">
            ولاية الانطلاق
          </label>
          <select id="guepex-wilaya"
            style="width:100%; padding:10px 12px; border:1px solid #d1d5db; border-radius:8px;
                   font-size:14px; background:#f9fafb; outline:none;">
            <option value="">— اختر الولاية —</option>
            ${wilayaOptions
              .map((w) => `<option value="${w}">${w}</option>`)
              .join("")}
          </select>
        </div>

        <div>
          <label style="display:block; margin-bottom:8px; font-weight:600; color:#374151; font-size:14px;">
            نوع التوصيل
          </label>
          <div style="display:flex; gap:10px;">
            <label id="guepex-fast-label"
              style="flex:1; display:flex; align-items:center; justify-content:center; gap:8px;
                     padding:12px; border:2px solid #9b59bf; border-radius:8px; cursor:pointer;
                     background:#f5eef9; font-weight:500; font-size:14px;">
              <input type="radio" name="guepex-speed" value="fast" checked
                style="accent-color:#9b59bf;" />
              سريع (Fast)
            </label>
            <label id="guepex-eco-label"
              style="flex:1; display:flex; align-items:center; justify-content:center; gap:8px;
                     padding:12px; border:2px solid #e5e7eb; border-radius:8px; cursor:pointer;
                     background:#fff; font-weight:500; font-size:14px;">
              <input type="radio" name="guepex-speed" value="economy"
                style="accent-color:#9b59bf;" />
              اقتصادي (Economy)
            </label>
          </div>
        </div>
      </div>
    `,
        showCancelButton: true,
        confirmButtonText: t("ship.export"),
        cancelButtonText: t("annule"),
        confirmButtonColor: "rgb(141, 93, 167)",
        cancelButtonColor: "#9ca3af",
        focusConfirm: false,
        didOpen: () => {
          const fastLabel = document.getElementById("guepex-fast-label");
          const ecoLabel = document.getElementById("guepex-eco-label");
          const radios = document.querySelectorAll(
            'input[name="guepex-speed"]',
          );

          const updateStyle = () => {
            const selected = document.querySelector(
              'input[name="guepex-speed"]:checked',
            )?.value;
            if (selected === "fast") {
              fastLabel.style.borderColor = "#9b59bf";
              fastLabel.style.background = "#f5eef9";
              ecoLabel.style.borderColor = "#e5e7eb";
              ecoLabel.style.background = "#fff";
            } else {
              ecoLabel.style.borderColor = "#9b59bf";
              ecoLabel.style.background = "#f5eef9";
              fastLabel.style.borderColor = "#e5e7eb";
              fastLabel.style.background = "#fff";
            }
          };

          radios.forEach((r) => r.addEventListener("change", updateStyle));
        },
        preConfirm: () => {
          const wilaya = document.getElementById("guepex-wilaya").value;
          const speed = document.querySelector(
            'input[name="guepex-speed"]:checked',
          )?.value;
          if (!wilaya) {
            Swal.showValidationMessage(t("ui.originStateRequired"));
            return false;
          }
          return { wilaya, speed };
        },
      });

      if (!formValues) return;

      try {
        await exportOrdersByCompany("guepex", selectedProducts, {
          departureWilaya: formValues.wilaya.toUpperCase(),
          isEconomy: formValues.speed === "economy",
        });
      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: "error",
          title: t("ui.exportFailed"),
          text: err.message || t("ui.exportError"),
          confirmButtonColor: "rgb(141, 93, 167)",
        });
      }
      return;
    }

    // other companies
    try {
      await exportOrdersByCompany(companyKey, selectedProducts);
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: t("ui.exportFailed"),
        text: err.message || t("ui.exportError"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    }
  };

  const handleExportDeskSelected = async (deskCode) => {
    const current = exportCurrentOrderRef.current;
    if (!current) return;

    exportDeskCodesRef.current = {
      ...exportDeskCodesRef.current,
      [current.id]: deskCode,
    };

    const remaining = exportDeskQueueRef.current.filter(
      (o) => o.id !== current.id,
    );
    exportDeskQueueRef.current = remaining;
    setExportDeskQueue(remaining);

    if (remaining.length > 0) {
      isAdvancingExportDeskQueueRef.current = true;

      setExportDeskModalOpen(false);
      exportCurrentOrderRef.current = null;
      setExportCurrentOrder(null);

      setTimeout(() => {
        exportCurrentOrderRef.current = remaining[0];
        setExportCurrentOrder(remaining[0]);
        setExportDeskModalKey((k) => k + 1);
        setExportDeskModalOpen(true);
        isAdvancingExportDeskQueueRef.current = false;
      }, 50);
      return;
    }

    setExportDeskModalOpen(false);
    setExportCurrentOrder(null);
    exportCurrentOrderRef.current = null;

    const ordersToExport =
      exportPendingOrdersRef.current || exportPendingOrders || selectedProducts;
    const codes = { ...exportDeskCodesRef.current };

    try {
      await exportOrdersByCompany("ecomdelivery", ordersToExport, {
        deskCodesByOrderId: codes,
      });
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: t("ui.exportFailed"),
        text: err.message || t("ui.exportError"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    } finally {
      setExportPendingOrders(null);
      exportPendingOrdersRef.current = null;
      exportDeskCodesRef.current = {};
      exportDeskQueueRef.current = [];
      isAdvancingExportDeskQueueRef.current = false;
    }
  };

  const handleExportZrHubSelected = async (selectedHub) => {
    const current = exportZrCurrentOrder;
    if (!current) return;

    const hubName =
      typeof selectedHub === "string"
        ? selectedHub
        : selectedHub?.name || selectedHub?.label || "";

    exportZrHubNamesRef.current = {
      ...exportZrHubNamesRef.current,
      [current.id]: hubName,
    };

    const remaining = exportZrHubQueue.filter((o) => o.id !== current.id);
    setExportZrHubQueue(remaining);

    if (remaining.length > 0) {
      setExportZrCurrentOrder(remaining[0]);
      setExportZrHubModalOpen(false);
      setTimeout(() => setExportZrHubModalOpen(true), 0);
      return;
    }

    // all hubs selected: export
    setExportZrHubModalOpen(false);
    setExportZrCurrentOrder(null);

    const ordersToExport = exportZrPendingOrders || selectedProducts;
    const hubs = { ...exportZrHubNamesRef.current };

    try {
      await exportOrdersByCompany("zrexpress", ordersToExport, {
        hubNamesByOrderId: hubs,
      });
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: t("ui.exportFailed"),
        text: err.message || t("ui.exportError"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    } finally {
      setExportZrPendingOrders(null);
      exportZrHubNamesRef.current = {};
    }
  };

  const dispatch = useDispatch();
  const [expandedRows, setExpandedRows] = useState(null);
  const productdata = useSelector((state) => state.ProductsReducer);
  const isDark = useIsDark();
  const [bluck, setBluck] = useState("");
  const [deleveryCompany, setDeleveryCompany] = useState("");
  const [selectedProducts, setSelectedProducts] = useState([]);
  let [page, setPage] = useState(1);
  const PER_PAGE = pageSize;
  const count = Math.ceil(orders.length / PER_PAGE);
  const _DATA = usePagination(orders, PER_PAGE);
  const products = useSelector((state) => state.ProductsReducer);
  const [showSubmenus, setShowSubmenus] = useState({});

  const [noestModalOpen, setNoestModalOpen] = useState(false);
  const [noestSelectedDeskCode, setNoestSelectedDeskCode] = useState(null);
  const [noestPendingData, setNoestPendingData] = useState(null);
  const [noestPendingResolve, setNoestPendingResolve] = useState(null);
  const [noestPendingReject, setNoestPendingReject] = useState(null);

  const [yalidineModalOpen, setYalidineModalOpen] = useState(false);
  const [yalidineSelectedDeskCode, setYalidineSelectedDeskCode] =
    useState(null);
  const [yalidinePendingData, setYalidinePendingData] = useState(null);
  const [yalidinePendingResolve, setYalidinePendingResolve] = useState(null);
  const [yalidinePendingReject, setYalidinePendingReject] = useState(null);

  const [ecomdeliveryModalOpen, setEcomdeliveryModalOpen] = useState(false);
  const [ecomdeliverySelectedDeskCode, setEcomdeliverySelectedDeskCode] =
    useState(null);
  const [ecomdeliveryPendingData, setEcomdeliveryPendingData] = useState(null);
  const [ecomdeliveryPendingResolve, setEcomdeliveryPendingResolve] =
    useState(null);
  const [ecomdeliveryPendingReject, setEcomdeliveryPendingReject] =
    useState(null);

  const [ecomdeliveryV2ModalOpen, setEcomdeliveryV2ModalOpen] = useState(false);
  const [ecomdeliveryV2SelectedDeskCode, setEcomdeliveryV2SelectedDeskCode] =
    useState(null);
  const [ecomdeliveryV2PendingData, setEcomdeliveryV2PendingData] =
    useState(null);
  const [ecomdeliveryV2PendingResolve, setEcomdeliveryV2PendingResolve] =
    useState(null);
  const [ecomdeliveryV2PendingReject, setEcomdeliveryV2PendingReject] =
    useState(null);

  const [ecotrackModalOpen, setEcotrackModalOpen] = useState(false);
  const [ecotrackSelectedDeskName, setEcotrackSelectedDeskName] =
    useState(null);
  const [ecotrackPendingData, setEcotrackPendingData] = useState(null);
  const [ecotrackPendingDesks, setEcotrackPendingDesks] = useState([]);
  const [ecotrackPendingResolve, setEcotrackPendingResolve] = useState(null);
  const [ecotrackPendingReject, setEcotrackPendingReject] = useState(null);

  const [zrExpressModalOpen, setZrExpressModalOpen] = useState(false);
  const [zrExpressSelectedHub, setZrExpressSelectedHub] = useState(null);
  const [zrExpressPendingData, setZrExpressPendingData] = useState(null);
  const [zrExpressPendingResolve, setZrExpressPendingResolve] = useState(null);
  const [zrExpressPendingReject, setZrExpressPendingReject] = useState(null);

  const [isMultiple, setIsMultiple] = useState(false);
  const zrHubsApiEndpoint = "https://backend.foorweb.store/api/zrexpress/hub";
  const zrHubsHeaders = useMemo(
    () => ({
      "X-Tenant": store?.zrExpressXTenant_V2 || "",
      "X-Api-Key": store?.zrExpressApiKey_V2 || "",
    }),
    [store?.zrExpressXTenant_V2, store?.zrExpressApiKey_V2],
  );
  const zrHubsSearchBody = useMemo(
    () => ({
      pageSize: 1000,
      pageNumber: 1,
      includeServices: true,
    }),
    [],
  );

  const dhdSelected = selectedProducts.filter(isDhdOrder);
  const canPrintDhd = isDhdUser && dhdSelected.length > 0;

  const handlePrintDhdBordereaux = async () => {
    if (!canPrintDhd || isPrintingBordereaux) return;

    const trackings = dhdSelected
      .map((o) => o.tracking)
      .filter((t) => t && String(t).trim());

    if (trackings.length === 0) {
      Swal.fire({
        icon: "warning",
        title: t("orders.datatable_templating_demo.error"),
        text: t("orders.datatable_templating_demo.print_dhd_no_tracking"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      return;
    }

    setIsPrintingBordereaux(true);
    try {
      await printDhdBordereaux(
        trackings,
        process.env.REACT_APP_BACKEND_DIGITALOCEAN_URL,
        account?.user,
      );
    } catch (err) {
      const code = err?.code;
      let text = err?.serverMessage || err?.message || String(err);

      if (code === "NO_TRACKINGS") {
        text = t("orders.datatable_templating_demo.print_dhd_no_tracking");
      } else if (code === "NOT_AUTHENTICATED") {
        text = t(
          "orders.datatable_templating_demo.print_dhd_not_authenticated",
        );
      } else if (
        typeof text === "string" &&
        text.includes("Ecotrack credentials")
      ) {
        text = t(
          "orders.datatable_templating_demo.print_dhd_missing_credentials",
        );
      }

      Swal.fire({
        icon: "error",
        title: t("orders.datatable_templating_demo.error"),
        text,
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    } finally {
      setIsPrintingBordereaux(false);
    }
  };

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };
  const [errorMessage, setErrorMessage] = useState("");
  const [currentDate, setCurrentDate] = useState("");

  const shouldIgnoreIsValid = (order) => {
    const status = String(order?.deleveryStatus || "");
    return status === "3" || status === "6";
  };

  // Set by order-app-backend (see buildRawMerchantOrder) on orders covered by
  // an unpaid FoorCall balance. Those orders arrive with no phone/phone2/
  // address at all, so this flag is the only way to tell "hidden for
  // non-payment" apart from "this order genuinely has no phone".
  const isBillingLocked = (order) => Boolean(order?.locked);

  // The per-order "spend a token to reveal this lead" lock — unrelated to
  // billing, and clearable by the merchant themselves.
  const isTokenLocked = (order) =>
    Boolean(order?.isValid) && !shouldIgnoreIsValid(order);

  const shouldShowLockedContent = (order) =>
    isBillingLocked(order) || isTokenLocked(order);

  // Unlike the token-spend lock, a billing lock can't be cleared by clicking —
  // it only goes away once the merchant's REQUIRED payment is resolved, so
  // clicking routes to the payment page instead of spending a token (which
  // wouldn't reveal anything: the phone was never sent to the browser).
  const handleLockedContentClick = (order) => {
    if (isBillingLocked(order)) {
      Swal.fire({
        icon: "warning",
        title: t("ui.foorcallPaymentRequired"),
        text: t("ui.foorcallOrderLocked"),
        confirmButtonText: t("formPreview.submitButton.default"),
        confirmButtonColor: "rgb(141, 93, 167)",
        showCancelButton: true,
        cancelButtonText: t("annule"),
        cancelButtonColor: "#e87778",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "/foorcall";
        }
      });
      return;
    }
    handlePay(order);
  };

  // A billing lock hides the phone, not the order: Preview and Edit stay open
  // so the merchant can still work the name/address/products/status. They're
  // safe to open because the phone isn't withheld by the UI — it never
  // arrived from the backend, so there's nothing for those screens to leak.
  //
  // A token lock is different: the phone IS present client-side, so opening
  // Preview/Edit would reveal what the merchant hasn't paid a token for.
  // Those still route through handlePay first.
  const guardLockedAction = (order, proceed) => {
    if (!isTokenLocked(order)) {
      proceed();
      return;
    }
    handlePay(order);
  };

  const getOrderContentKey = (order) => {
    if (Array.isArray(order?.products) && order.products.length > 0) {
      return order.products
        .map((p) => {
          const id = p.id || p.productId || "";
          const qty = p.qty ?? p.quantity ?? 1;
          const opts = p.options ? JSON.stringify(p.options) : "";
          return `${id}:${qty}:${opts}`;
        })
        .sort()
        .join("|");
    }

    const id = order?.productId || "";
    const qty = order?.qty ?? 1;
    const name = order?.nameproduct || "";
    return `${id}:${qty}:${name}`;
  };

  const normalizePhoneForDuplicate = (phone) => {
    const digitsOnly = String(phone || "").replace(/\D/g, "");
    if (!digitsOnly) return "";
    return digitsOnly.slice(-9);
  };

  const getOrderDayKey = (order) => {
    const raw = order?.timeStamp;
    if (!raw) return "";

    let dateValue;
    if (raw?.seconds) {
      dateValue = new Date(raw.seconds * 1000);
    } else {
      dateValue = new Date(raw);
    }

    if (Number.isNaN(dateValue.getTime())) return "";

    const year = dateValue.getFullYear();
    const month = String(dateValue.getMonth() + 1).padStart(2, "0");
    const day = String(dateValue.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const autoMarkDuplicateOrders = async () => {
      if (!Array.isArray(orders) || orders.length < 2) return;

      const groupedOrders = new Map();

      orders.forEach((order) => {
        const status = String(order?.deleveryStatus || "");
        if (status === "20" || status === "8") return; // متروكة or deleted

        const phoneKey = normalizePhoneForDuplicate(order?.phone);
        const dayKey = getOrderDayKey(order);
        if (!phoneKey || !dayKey) return;

        // duplicated orders = same phone && same day && same product
        const contentKey = getOrderContentKey(order);
        const groupKey = `${phoneKey}|${dayKey}|${contentKey}`;
        if (!groupedOrders.has(groupKey)) {
          groupedOrders.set(groupKey, []);
        }
        groupedOrders.get(groupKey).push(order);
      });

      const getOrderTimestampMs = (order) => {
        const raw = order?.timeStamp;
        if (raw?.seconds) return raw.seconds * 1000;
        const parsed = new Date(raw).getTime();
        return Number.isNaN(parsed) ? Number.MAX_SAFE_INTEGER : parsed;
      };

      const hasAlreadyBeenAutoMarkedDuplicate = (order) =>
        Array.isArray(order?.statusTimeline) &&
        order.statusTimeline.some(
          (entry) =>
            String(entry?.status) === "6-2" &&
            String(entry?.ownby || "").toLowerCase() === "automatique",
        );

      const duplicatesToUpdate = [];
      groupedOrders.forEach((group) => {
        if (group.length >= 2) {
          const orderedGroup = [...group].sort(
            (left, right) =>
              getOrderTimestampMs(left) - getOrderTimestampMs(right),
          );

          orderedGroup.slice(1).forEach((order) => {
            if (
              String(order?.deleveryStatus) !== "6-2" &&
              !hasAlreadyBeenAutoMarkedDuplicate(order)
            ) {
              duplicatesToUpdate.push(order);
            }
          });
        }
      });

      if (duplicatesToUpdate.length === 0) return;

      try {
        const batch = writeBatch(db);
        const now = new Date();

        duplicatesToUpdate.forEach((order) => {
          const nextTimeline = [
            ...(order.statusTimeline || []),
            { status: "6-2", timestamp: now, ownby: "Automatique" },
          ];

          const updatedOrder = {
            ...order,
            deleveryStatus: "6-2",
            statusTimeline: nextTimeline,
            ownby: "Automatique",
          };

          batch.set(doc(db, "orders", order.id), updatedOrder);
        });

        await batch.commit();

        const updatedById = new Map(
          duplicatesToUpdate.map((order) => {
            const nextTimeline = [
              ...(order.statusTimeline || []),
              { status: "6-2", timestamp: now, ownby: "Automatique" },
            ];

            return [
              order.id,
              {
                ...order,
                deleveryStatus: "6-2",
                statusTimeline: nextTimeline,
                ownby: "Automatique",
              },
            ];
          }),
        );

        updatedById.forEach((updatedOrder, orderId) => {
          onStatusChange(orderId, updatedOrder);
        });

        dispatch(
          fetchOrders(
            ordersState.map((order) => updatedById.get(order.id) || order),
          ),
        );
      } catch (error) {
        console.error("Erreur auto-duplicate (6-2):", error);
      }
    };

    autoMarkDuplicateOrders();
  }, [orders, ordersState, dispatch, onStatusChange]);

  const generateFileName = () => {
    // الحصول على التاريخ والوقت الحالي
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // الشهر يبدأ من 0
    const day = String(currentDate.getDate()).padStart(2, "0");
    const hours = String(currentDate.getHours()).padStart(2, "0");
    const minutes = String(currentDate.getMinutes()).padStart(2, "0");

    // بناء اسم الملف مع التاريخ والوقت
    return `ordersfoorweb_${year}-${month}-${day}_${hours}:${minutes}.csv`;
  };

  useEffect(() => {
    const fetchAndSetCurrentDate = async () => {
      const res = await fetchDate();
      setCurrentDate(res);
    };

    fetchAndSetCurrentDate();

    const interval = setInterval(() => fetchAndSetCurrentDate(), 60000); // Fetch date every minute
    return () => clearInterval(interval); // Cleanup function
  }, []);

  useEffect(() => {
    // Vérifier les commandes toutes les minutes
    const interval = setInterval(() => {
      const now = new Date();
      // Ne vérifier que vers minuit pour économiser des ressources
      if (now.getHours() === 0 && now.getMinutes() <= 1) {
        orders.forEach((order) => {
          checkAndUpdateStatusAtMidnight(order);
        });
      }
    }, 3600000); // Vérifier toutes les minutes

    return () => clearInterval(interval);
  }, [orders]);

  const statusBodyTemplate = (rowData) => {
    let color = "#fff";
    if (rowData.deleveryStatus === "1") {
      color = "#fff";
    }
    if (rowData.deleveryStatus === "2") {
      color = "#e1a626";
    }
    if (rowData.deleveryStatus === "3") {
      color = "#25c7bf";
    }
    if (rowData.deleveryStatus === "4") {
      color = "#8c5fa5";
    }
    if (rowData.deleveryStatus === "5") {
      color = "#49a688";
    }
    if (rowData.deleveryStatus === "6") {
      color = "#e87778";
    }
    if (rowData.deleveryStatus === "6-4") {
      color = "#e87778";
    }
    if (rowData.deleveryStatus === "11-1") {
      color = "#0074D9";
    }
    if (rowData.deleveryStatus === "11-2") {
      color = "#D3D3D9";
    }
    if (rowData.deleveryStatus === "11-3") {
      color = "#e1a626";
    }
    if (rowData.deleveryStatus === "11-4") {
      color = "#000000";
    }
    if (rowData.deleveryStatus === "11-5") {
      color = "#800080";
    }
    if (rowData.deleveryStatus === "11") {
      color = "#e1a626";
    }
    return (
      <Form.Select
        aria-label={t("ship.order_status")}
        className={
          rowData.deleveryStatus === "1" ? `text-dark n-status` : `text-white `
        }
        value={rowData.deleveryStatus}
        onChange={(e) => {
          changeStatus(rowData, e.target.value);
        }}
        style={{
          backgroundColor: `${color}`,
          zIndex: "9000",
        }}
      >
        {rowData.deleveryStatus !== "5" && (
          <>
            <option value="1">
              {t("orders.datatable_templating_demo.new")}
            </option>
            <option value="3">
              {t("orders.datatable_templating_demo.confirmed")}
            </option>
            <option value="9">
              {t("orders.datatable_templating_demo.confirmed_by_customer")}
            </option>
            <option value="11-2">
              {t("orders.datatable_templating_demo.no_response_to_call")}
            </option>
            <option value="11-3">
              {t("orders.datatable_templating_demo.postponed")}
            </option>
            {rowData.deleveryStatus !== "5" && (
              <option value="6">
                {t("orders.datatable_templating_demo.cancelled")}
              </option>
            )}
            <option value="6-4">
              {t("orders.datatable_templating_demo.cancelled_auto")}
            </option>
            <option value="11-5">
              {t("orders.datatable_templating_demo.cancelled_by_customer")}
            </option>
            <option value="11-1">
              {t("orders.datatable_templating_demo.awaiting_customer_contact")}
            </option>
            <option value="11-4">
              {t("orders.datatable_templating_demo.line_busy")}
            </option>
            <option value="4">
              {t("orders.datatable_templating_demo.with_delivery_company")}
            </option>
          </>
        )}
        <option value="5">
          {t("orders.datatable_templating_demo.completed")}
        </option>
      </Form.Select>
    );
  };

  moment.defineLocale("fr-num", {
    parentLocale: "fr",
    months: moment.locales("fr").months,
    monthsShort: moment.locales("fr").monthsShort,
    weekdays: moment.locales("fr").weekdays,
    weekdaysShort: moment.locales("fr").weekdaysShort,
    weekdaysMin: moment.locales("fr").weekdaysMin,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "YYYY-MM-DD",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm",
    },
    relativeTime: {
      future: "dans %s",
      past: "il y a %s",
      s: "quelques secondes",
      ss: "%d secondes",
      m: "une minute",
      mm: "%d minutes",
      h: "une heure",
      hh: "%d heures",
      d: "un jour",
      dd: "%d jours",
      M: "un mois",
      MM: "%d mois",
      y: "une année",
      yy: "%d années",
    },
    preparse: function (string) {
      return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
        return "٠١٢٣٤٥٦٧٨٩".indexOf(match);
      });
    },
  });

  useEffect(() => {
    if (errorMessage) {
      Swal.fire({
        title: t("orders.datatable_templating_demo.error"),
        text: errorMessage,
        icon: "error",
        confirmButtonText: t("orders.datatable_templating_demo.okay"),
      }).then(() => {
        setErrorMessage("");
      });
    }
  }, [errorMessage]);

  const handleNoestDeskSelected = async (selectedDeskCode) => {
    if (noestPendingData && noestPendingResolve) {
      try {
        const result = await changeShip(noestPendingData, "4", {
          selectedDeskCode,
        });
        noestPendingResolve(result);
      } catch (error) {
        noestPendingReject(error);
      } finally {
        setNoestPendingData(null);
        setNoestPendingResolve(null);
        setNoestPendingReject(null);
      }
    }
    setNoestModalOpen(false);
  };

  const handleNoestModalClose = () => {
    if (noestPendingReject) {
      // noestPendingReject(new Error("Sélection annulée"));
      setNoestPendingData(null);
      setNoestPendingResolve(null);
      setNoestPendingReject(null);
    }
    setNoestModalOpen(false);
  };

  const handleYalidineDeskSelected = async (selectedDeskCode) => {
    if (yalidinePendingData && yalidinePendingResolve) {
      try {
        const result = await changeShip(yalidinePendingData, "5", {
          selectedDeskCode,
        });
        yalidinePendingResolve(result);
      } catch (error) {
        yalidinePendingReject(error);
      } finally {
        setYalidinePendingData(null);
        setYalidinePendingResolve(null);
        setYalidinePendingReject(null);
      }
    }
    setYalidineModalOpen(false);
  };

  const handleYalidineModalClose = () => {
    if (yalidinePendingReject) {
      // yalidinePendingReject(new Error("Sélection annulée"));
      setYalidinePendingData(null);
      setYalidinePendingResolve(null);
      setYalidinePendingReject(null);
    }
    setYalidineModalOpen(false);
  };

  const handleEcomdeliveryDeskSelected = async (selectedDeskCode) => {
    if (ecomdeliveryPendingData && ecomdeliveryPendingResolve) {
      try {
        const result = await changeShip(ecomdeliveryPendingData, "14", {
          ecomdeliverySelectedDeskCode: selectedDeskCode,
        });
        ecomdeliveryPendingResolve(result);
      } catch (error) {
        ecomdeliveryPendingReject(error);
      } finally {
        setEcomdeliveryPendingData(null);
        setEcomdeliveryPendingResolve(null);
        setEcomdeliveryPendingReject(null);
        setEcomdeliverySelectedDeskCode(null);
      }
    }
    setEcomdeliveryModalOpen(false);
  };

  const handleEcomdeliveryModalClose = () => {
    if (ecomdeliveryPendingReject) {
      setEcomdeliveryPendingData(null);
      setEcomdeliveryPendingResolve(null);
      setEcomdeliveryPendingReject(null);
    }
    setEcomdeliveryModalOpen(false);
  };

  const handleEcomdeliveryV2DeskSelected = async (selectedDeskCode) => {
    if (ecomdeliveryV2PendingData && ecomdeliveryV2PendingResolve) {
      try {
        const result = await changeShip(ecomdeliveryV2PendingData, "18", {
          ecomdeliveryV2SelectedDeskCode: selectedDeskCode,
        });
        ecomdeliveryV2PendingResolve(result);
      } catch (error) {
        ecomdeliveryV2PendingReject(error);
      } finally {
        setEcomdeliveryV2PendingData(null);
        setEcomdeliveryV2PendingResolve(null);
        setEcomdeliveryV2PendingReject(null);
        setEcomdeliveryV2SelectedDeskCode(null);
      }
    }
    setEcomdeliveryV2ModalOpen(false);
  };

  const handleEcomdeliveryV2ModalClose = () => {
    if (ecomdeliveryV2PendingReject) {
      setEcomdeliveryV2PendingData(null);
      setEcomdeliveryV2PendingResolve(null);
      setEcomdeliveryV2PendingReject(null);
    }
    setEcomdeliveryV2ModalOpen(false);
  };

  const handleEcotrackDeskSelected = async (desk) => {
    setEcotrackSelectedDeskName(desk);
    setEcotrackModalOpen(false);

    const orderData = ecotrackPendingData;
    const resolve = ecotrackPendingResolve;
    const reject = ecotrackPendingReject;

    setEcotrackPendingData(null);
    setEcotrackPendingDesks([]);
    setEcotrackPendingResolve(null);
    setEcotrackPendingReject(null);

    if (!orderData) {
      if (typeof resolve === "function") resolve({ cancelled: true });
      return;
    }

    try {
      await runChangeShip({
        data: orderData,
        status: "3",
        store,
        products: productdata,
        setErrorMessage: (msg) => {
          if (msg) {
            Swal.fire({
              icon: "error",
              title: t("error"),
              text: msg,
              confirmButtonColor: "rgb(141, 93, 167)",
            });
          }
        },
        t,
        ecotrackSelectedDeskName: desk,
        setEcotrackPendingData,
        setEcotrackPendingDesks,
        setEcotrackPendingResolve,
        setEcotrackPendingReject,
        setEcotrackModalOpen,
        onSuccess: () => {},
      });
      if (typeof resolve === "function") resolve({ success: true });
    } catch (err) {
      if (typeof reject === "function") reject(err);
      else console.error(err);
    } finally {
      setEcotrackSelectedDeskName(null);
    }
  };

  const handleEcotrackModalClose = () => {
    setEcotrackModalOpen(false);
    setEcotrackPendingData(null);
    setEcotrackPendingDesks([]);
    setEcotrackSelectedDeskName(null);

    if (typeof ecotrackPendingResolve === "function") {
      ecotrackPendingResolve({ cancelled: true });
    }

    setEcotrackPendingResolve(null);
    setEcotrackPendingReject(null);
  };

  const handleZrExpressHubSelected = async (selectedHub) => {
    setZrExpressSelectedHub(selectedHub);
    if (zrExpressPendingData && zrExpressPendingResolve) {
      try {
        const result = await changeShip(zrExpressPendingData, "16", {
          zrExpressSelectedHub: selectedHub,
        });
        zrExpressPendingResolve(result);
      } catch (error) {
        zrExpressPendingReject(error);
      } finally {
        setZrExpressPendingData(null);
        setZrExpressPendingResolve(null);
        setZrExpressPendingReject(null);
        setZrExpressSelectedHub(null);
      }
    }
    setZrExpressModalOpen(false);
  };

  const handleZrExpressModalClose = () => {
    if (zrExpressPendingReject) {
      setZrExpressPendingData(null);
      setZrExpressPendingResolve(null);
      setZrExpressPendingReject(null);
      setZrExpressSelectedHub(null);
    }
    setZrExpressModalOpen(false);
  };

  const dateBodyTemplate = (rowData) => {
    const timestamp = rowData.timeStamp?.seconds * 1000;
    const now = Date.now();
    const date = moment(timestamp).locale("fr-num"); // تعيين اللغة الفرنسية مع الأرقام

    const diff = now - timestamp;

    if (diff < 60000) {
      // أقل من دقيقة واحدة
      return (
        <span>
          {t("orders.datatable_templating_demo.since")}{" "}
          {Math.floor(diff / 1000)}{" "}
          {t("orders.datatable_templating_demo.seconds")}
        </span>
      );
    } else if (diff < 3600000) {
      // أقل من ساعة واحدة
      return (
        <span>
          {t("orders.datatable_templating_demo.since")}{" "}
          {Math.floor(diff / 60000)}{" "}
          {t("orders.datatable_templating_demo.minutes")}
        </span>
      );
    } else if (diff < 86400000) {
      // أقل من يوم واحد
      return (
        <span>
          {t("orders.datatable_templating_demo.since")}{" "}
          {Math.floor(diff / 3600000)}{" "}
          {t("orders.datatable_templating_demo.hours")}
        </span>
      );
    } else if (diff < 604800000) {
      // أقل من أسبوع واحد
      return (
        <span>
          {t("orders.datatable_templating_demo.since")}{" "}
          {Math.floor(diff / 86400000)}{" "}
          {t("orders.datatable_templating_demo.days")}
        </span>
      );
    } else if (diff < 604800000 + 86400000) {
      // أقل من أسبوع واحد
      return (
        <span>
          {t("orders.datatable_templating_demo.since")}{" "}
          {t("orders.datatable_templating_demo.a_week")}
        </span>
      );
    } else {
      return <span>{date.format("YYYY-MM-DD, H:mm:ss")}</span>;
    }
  };

  const changeShip = async (data, status, overrides = {}) => {
    try {
      const result = await runChangeShip({
        data,
        status,
        store,
        products: productss,
        setErrorMessage,
        t,
        noestSelectedDeskCode,
        yalidineSelectedDeskCode,
        setNoestPendingData,
        setNoestPendingResolve,
        setNoestPendingReject,
        setNoestModalOpen,
        setYalidinePendingData,
        setYalidinePendingResolve,
        setYalidinePendingReject,
        setYalidineModalOpen,
        ecomdeliverySelectedDeskCode,
        setEcomdeliveryPendingData,
        setEcomdeliveryPendingResolve,
        setEcomdeliveryPendingReject,
        setEcomdeliveryModalOpen,
        ecomdeliveryV2SelectedDeskCode,
        setEcomdeliveryV2PendingData,
        setEcomdeliveryV2PendingResolve,
        setEcomdeliveryV2PendingReject,
        setEcomdeliveryV2ModalOpen,
        ecotrackSelectedDeskName,
        setEcotrackPendingData,
        setEcotrackPendingDesks,
        setEcotrackPendingResolve,
        setEcotrackPendingReject,
        setEcotrackModalOpen,
        zrExpressSelectedHub,
        setZrExpressPendingData,
        setZrExpressPendingResolve,
        setZrExpressPendingReject,
        setZrExpressModalOpen,
        ...overrides,
        onSuccess: (updatedOrder) => {
          try {
            onStatusChange(data.id, updatedOrder);
            dispatch(
              fetchOrders([
                ...ordersState.map((o) =>
                  o.id === data.id ? updatedOrder : o,
                ),
              ]),
            );
          } catch (e) {
            console.error("onSuccess handler error:", e);
          }
        },
      });

      return result;
    } catch (error) {
      const message = getUploadLivraisonErrorMessage(error);
      if (message) setErrorMessage(message);
      console.error("Error in changeShip:", error);
      throw error;
    }
  };
  const currencyMap = {
    دج: {
      ar: "دج",
      fr: "DA",
      en: "DZD",
    },
  };
  // retourne le total de la commande
  const orderTotal = (rowData) => {
    return (
      <>
        <span className="bg-[#faf1ff] dark:bg-[#3c3a3d] text-[#9e68ba] dark:text-[#e4b8e4] px-3 py-1 rounded-lg">
          {rowData.total} {currencyMap[store.currencySymbol]?.[i18n.language]}
        </span>
      </>
    );
  };
  const localizedCurrency =
    currencyMap[store.currencySymbol]?.[i18n.language] || store.currencySymbol;
  // lien vers le nom
  const customerName = (rowData) => {
    const commercantNote = rowData?.commercantNote;

    return (
      <div className="flex items-center gap-1">
        <Link
          style={{ textDecoration: "none" }}
          to={`/orderProfile/${rowData.id}`}
          state={{
            orderData: rowData, // consistent key
            filteredOrderIds: orders.map((o) => o.id),
            product: productdata.find(
              (product) => product.id === rowData.productId,
            ),
            products: productdata,
          }}
        >
          {rowData.name}
        </Link>
      </div>
    );
  };
  // 6-1 6-2 6-3 6-4
  const statusOptions = {
    1: "جديد",
    3: "مؤكدة",
    9: "مؤكدة من قبل العميل",
    "11-2": "لم يرد على الاتصال",
    "11-3": "مؤجلة",
    6: "ملغي",
    "6-4": "ملغي تلقائيا",
    "11-5": "ملغى من قبل العميل",
    "11-1": "انتظار اتصال العميل",
    "11-4": "الخط مغلق",
    4: "رفع لشركة التوصيل",
    5: "مكتملة",
  };

  // دالة لتقليل النص وإضافة النقاط الثلاث إذا كان أطول من الحد الأقصى
  const maxChars = 25;
  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength - 3) + "...";
    }
    return text;
  };

  // Met à jour le statut d'une commande, enregistre l'historique des statuts et envoie une notification Telegram au client.
  const changeStatus = async (data, status, options = {}) => {
    // Not paid (billing or per-order token lock) — no status change until
    // the merchant resolves the lock, same message as clicking the lock icon.
    if (shouldShowLockedContent(data)) {
      handleLockedContentClick(data);
      return;
    }

    const { skipTelegram = false } = options;
    const currentTime = new Date();
    const updatedStatusTimeline = [
      ...(data.statusTimeline || []),
      { status, timestamp: currentTime, ownby: account.name },
    ];
    const telegramBotToken = "6672968395:AAHFokejZq4r6GRRDHlm2FDqXk0-pXoQmOs";
    const chatId = store.Idtelegram;
    const product = productdata.find(
      (product) => product.id === data.productId,
    );
    const truncatedProductName = truncateText(
      data.nameproduct ? data.nameproduct : product.name,
      maxChars,
    );
    const statusMessages = {};

    if (store.done === true) {
      statusMessages["5"] =
        `✅ تم إتمام الطلب بنجاح! ✅\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nنود إبلاغكم بأنه تم إتمام الطلب بنجاح. يمكنكم متابعة تفاصيل وضعية الطلب وموعد التسليم عبر البوابة الخاصة بكم. شكرًا لتفهمكم وثقتكم في خدماتنا.`;
    }
    const statusMessagess = {};

    if (store.termine === true) {
      statusMessagess["11-2"] =
        `📢 طلب لم يرد على الاتصال! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: "لم يرد على الاتصال". نقترح محاولة الاتصال مع العميل لاحقًا لتأكيد التفاصيل. شكرًا لك على تفانيك في تقديم خدمة عالية الجودة.`;
      statusMessagess["11-3"] =
        `📢 طلب مؤجل! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تأجيل تسليم الطلب إلى وقت لاحق. ننصح بجدولة الاتصال بالعميل لترتيب تفاصيل موعد التسليم المناسب. نقدر جهودك في تقديم الخدمة المميزة.`;
      statusMessagess["11-5"] =
        `📢 إلغاء طلب! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم إلغاء الطلب من قبل العميل. يُرجى ترتيب إجراءات الإلغاء ومتابعة الإجراءات المناسبة. نشكرك على تفهمك واهتمامك برضاء العملاء.`;
      statusMessagess["11-1"] =
        `📢 انتضار اتصال العميل ! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: "انتظار اتصال العميل". يُرجى محاولة التواصل مع العميل بأسرع وقت ممكن لتأكيد التفاصيل وترتيب التسليم المناسب. شكرًا لك على اهتمامك بتقديم الخدمة الفائقة.`;
      statusMessagess["11-4"] =
        `📢 طلب خط مغلق! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: "الخط مغلق". نود إبلاغك بأن العميل قد يكون غير متاح حاليًا. ننصح بمحاولة الاتصال في وقت لاحق أو ترتيب وقت مناسب للتواصل. نشكرك على جهودك في تقديم أفضل خدمة للعملاء.`;
    }

    const statusMessagees = {};

    if (store.confrim === true) {
      statusMessagees["3"] =
        `📢 طلب مؤكد! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: "مؤكدة". ننصح برفع الطلب في شركة التوصيل لبدء إجراءات التوصيل. شكرًا لك على جهودك في تقديم أفضل تجربة للعميل وتسهيل عملية التسليم.`;
    }
    if (store.confrim === true) {
      statusMessagees["9"] =
        `📢 طلب مؤكد من قبل العميل! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nتم تحديث حالة الطلب إلى: "مؤكدة". ننصح برفع الطلب في شركة التوصيل لبدء إجراءات التوصيل. شكرًا لك على جهودك في تقديم أفضل تجربة للعميل وتسهيل عملية التسليم.`;
    }
    const statusMessageesNew = {};

    if (store.new === true) {
      statusMessageesNew["1"] =
        `📢 تحديث حالة الطلب! 📢\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nلدينا تحديث جديد على حالة الطلب. يُرجى تأكيد ومتابعة الحالة الجديدة في أقرب وقت ممكن. شكرًا لك على اهتمامك بتقديم خدمة مميزة وتلبية احتياجات العملاء بكل دقة وسرعة.`;
    }

    const statusMessagessDD = {};

    if (store.delevery === true) {
      statusMessagessDD["4"] =
        `🚚 طلب تم رفعه لشركة التوصيل! 🚚\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nنود إعلامك بأنه تم رفع الطلب لشركة التوصيل بنجاح. يتم الآن التنسيق لبدء عملية التسليم. نشكرك على جهودك واهتمامك بتقديم تجربة مميزة للعميل.`;
    }
    const statusMessagessCC = {};

    if (store.cancel === true) {
      statusMessagessDD["6"] =
        `❌ تم الغاء الطلب! ❌\n\n👤 العميل: ${data.name}\n📞 الهاتف: ${data.phone}\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nنأسف لإبلاغكم بأن العميل قام بإلغاء الطلب. تم تحديث حالة الطلب بنجاح. شكرًا على جهودك في تقديم الخدمة ونأمل في تقديم تجربة أفضل في المستقبل.`;
    }
    const message =
      statusMessages[status] ||
      statusMessagees[status] ||
      statusMessagessCC[status] ||
      statusMessageesNew[status] ||
      statusMessagessDD[status] ||
      statusMessagess[status];
    const messageC = `📵 حالة الطلب غير مكتملة! 📵\n\n👤 العميل: ${data.name}\n📞 الهاتف: ********\n🌍 الولاية: ${data.state}\n🛍 المنتج: ${truncatedProductName}\n\nنرجو إعلامك بأن رقم هاتف الطلب غير ظاهر بسبب عدم توفر رصيد كافي أو عدم تفعيل باقتك في فوورويب . يُرجى التحقق من حالة رصيدك وتفعيل الباقة لتتمكن من متابعة تفاصيل طلبك بشكل كامل. شكرًا على تفهمك ونتطلع لخدمتك بشكل أفضل.`;

    try {
      const shouldDecreaseStock =
        String(status) === "5" &&
        String(data?.deleveryStatus) !== "5" &&
        !data?.stockDeducted;

      if (shouldDecreaseStock) {
        const stockResult = await decreaseOrderProductsStock({
          db,
          order: data,
          productsCatalog: productdata,
        });

        if (Array.isArray(stockResult?.updatedProducts)) {
          stockResult.updatedProducts.forEach((updatedProduct) => {
            dispatch(updateProduct(updatedProduct));
          });
        }
      }

      const updatedOrder = {
        ...data,
        deleveryStatus: status,
        statusTimeline: updatedStatusTimeline,
        ownby: account.name,
        ...(shouldDecreaseStock ? { stockDeducted: true } : {}),
      };

      await setDoc(doc(db, "orders", data.id), updatedOrder);

      // Mettre à jour le state local du parent en temps réel pour synchroniser les compteurs de filtres
      onStatusChange(data.id, updatedOrder);

      // Synchroniser vers Redux
      dispatch(
        fetchOrders([
          ...ordersState.map((o) => (o.id === data.id ? updatedOrder : o)),
        ]),
      );

      if (!skipTelegram) {
        {
          data.isValid
            ? axios
                .post(
                  `https://api.telegram.org/bot${telegramBotToken}/sendMessage`,
                  {
                    chat_id: chatId,
                    text: messageC,
                  },
                )
                .catch((error) => {
                  console.error("حدث خطأ أثناء إرسال الإشعار", error);
                })
            : axios
                .post(
                  `https://api.telegram.org/bot${telegramBotToken}/sendMessage`,
                  {
                    chat_id: chatId,
                    text: message,
                  },
                )
                .catch((error) => {
                  console.error("حدث خطأ أثناء إرسال الإشعار", error);
                });
        }
      }
    } catch (error) {
      console.error("Error updating order status:", error);
    }
  };

  //update paid
  const changepaid = async (data, status) => {
    try {
      const updatedOrder = { ...data, paid: status };
      await setDoc(doc(db, "orders", data.id), updatedOrder);

      // Mettre à jour le state local du parent
      onStatusChange(data.id, updatedOrder);

      // Synchroniser vers Redux
      dispatch(
        fetchOrders([
          ...ordersState.map((o) => (o.id === data.id ? updatedOrder : o)),
        ]),
      );
    } catch (error) {
      console.error("Error updating paid status:", error);
    }
  };

  /** Fonction pour générer le contenu de la ligne étendue dans un tableau de commandes.

  Cette fonction affiche les détails des produits d'une commande avec la possibilité
  d'effectuer plusieurs actions, notamment :

  - Ajouter ou supprimer une adresse IP à la liste des adresses bloquées.
  - Supprimer un produit spécifique d'une commande.
  - Afficher les détails des produits avec des options dynamiques (couleur, taille, etc.).
  - Gérer l'affichage des sous-menus des produits.*/
  const rowExpansionTemplate = (data) => {
    const addIpToAdressipblock = async (data) => {
      Swal.fire({
        title: t("ship.confirm_block"),
        text: t("orderDetails.alerts.block.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "rgb(141, 93, 167)",
        cancelButtonColor: "#e87778",
        confirmButtonText: t("ship.confirm_block_button"),
        cancelButtonText: t("annule"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          const storeDocRef = doc(db, "store", store.id);

          if (data.ipAddress) {
            try {
              await updateDoc(storeDocRef, {
                Adressipblock: arrayUnion(data.ipAddress),
              });
              apicache(account, products);
              Swal.fire(
                t("ship.block_success"),
                ". تم حظر عنوان الايبي بنجاح",
                "success",
              );
            } catch (error) {
              console.error("Error adding الايبي: ", error);
              Swal.fire(
                t("ship.error"),
                ". حدث خطأ أثناء حظر عنوان الايبي",
                "error",
              );
            }
          } else {
            console.error("No الايبي address found in data");
            Swal.fire(
              t("ship.error"),
              ". لا يوجد عنوان الايبي في الطلب",
              "error",
            );
          }
        }
      });
    };
    const toggleSubmenu = (productId) => {
      setShowSubmenus((prevShowSubmenus) => ({
        ...prevShowSubmenus,
        [productId]: !prevShowSubmenus[productId],
      }));
    };
    const onDelete = async (product) => {
      try {
        const orderRef = doc(db, "orders", data.id); // استبدل "وثيقة_طلبك" بمعرف الوثيقة الفعلي
        await updateDoc(orderRef, {
          products: arrayRemove(product), // استخدم الكائن الكامل للحذف
        });
      } catch (e) {
        console.error("خطأ عند حذف المنتج: ", e);
      }
    };

    const removeIpFromAdressipblock = async (data) => {
      Swal.fire({
        title: t("ship.confirm_delete"),
        text: t("orderDetails.alerts.unblock.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "rgb(141, 93, 167)",
        cancelButtonColor: "#e87778",
        confirmButtonText: t("orderDetails.alerts.unblock.confirm"),
        cancelButtonText: t("annule"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          const storeDocRef = doc(db, "store", store.id);

          if (data.ipAddress) {
            try {
              await updateDoc(storeDocRef, {
                Adressipblock: arrayRemove(data.ipAddress),
              });
              Swal.fire(
                t("ship.delete_success"),
                ". تم حذف عنوان الايبي بنجاح",
                "success",
              );
            } catch (error) {
              console.error("Error removing الايبي: ", error);
              Swal.fire(
                t("ship.error"),
                ". حدث خطأ أثناء حذف عنوان الايبي",
                "error",
              );
            }
          } else {
            console.error("No الايبي address found in data");
            Swal.fire(
              t("ship.error"),
              ". لا يوجد عنوان الايبي في الطلب",
              "error",
            );
          }
        }
      });
    };
    const timestamp = data.timeStamp;
    const date = new Date(timestamp.seconds * 1000); // تحويل ثواني الوقت إلى مللي ثواني وإنشاء كائن التاريخ
    const formattedDate = date.toLocaleString();
    const product = productdata.find(
      (product) => product.id === data.productId,
    );
    let productsToShow = [];
    if (data.products && data.products.length > 0) {
      productsToShow = data.products.map((p) =>
        productdata.find((product) => product.id === p.id),
      );
    }
    return (
      <div className="orders-subtable row">
        <div className="max-w-2xl mx-auto py-0 md:px-8">
          {data.nameproduct ? (
            <>
              {data.products ? (
                <ul>
                  {data.products.map((product) => (
                    <div
                      className="max-w-2xl mx-auto py-0 md:px-2 relative"
                      key={product.name}
                    >
                      <div
                        className="d-flex justify-content-between w-100 p-1-2 border4 card"
                        onClick={() => toggleSubmenu(product.name)}
                      >
                        <li className="flex gap-4 items-center">
                          <img
                            src={
                              product.image
                                ? product.image
                                : "/product-foorweb.png"
                            }
                            className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                          />
                          <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                            {product.name}
                          </div>
                          <span className="text-sm">
                            {product.price} {localizedCurrency}
                          </span>
                          <i
                            className={`bi ${
                              showSubmenus[product.name]
                                ? "bi-chevron-double-up"
                                : "bi-chevron-double-down"
                            }`}
                            style={{ color: "#45a788" }}
                          ></i>
                        </li>
                      </div>

                      <div
                        className={`submenu ${
                          showSubmenus[product.name] ? "" : "open"
                        }`}
                      >
                        <div className="w-100 p-1-2 border4 ">
                          {product?.options?.offer && (
                            <div className="d-flex justify-content-between w-100 p-1-2-3">
                              <p className="m-0">{t("offer")} :</p>
                              <p className="m-0 text-success">
                                <b>{product?.options?.offer}</b>
                              </p>
                            </div>
                          )}
                          {product?.options?.offer && (
                            <hr className="m-0 p-0" />
                          )}
                          <div className="d-flex justify-content-between w-100 p-1-2-3">
                            <p className="m-0"> {t("color")} :</p>
                            <p className="m-0 text-success">
                              <b>
                                <b>
                                  <b>
                                    {typeof product?.options?.color ===
                                      "object" &&
                                    !Array.isArray(product?.options?.color)
                                      ? Object.entries(product?.options?.color)
                                          .length > 0
                                        ? Object.entries(
                                            product?.options?.color,
                                          ).map(([key, value]) => (
                                            <span key={key}>
                                              {key}:{" "}
                                              {Array.isArray(value)
                                                ? value.join(", ")
                                                : value}
                                              <br />
                                            </span>
                                          ))
                                        : t("unspecified")
                                      : typeof product?.options?.color ===
                                          "string"
                                        ? product?.options?.color.trim() === ""
                                          ? t("unspecified")
                                          : product?.options?.color
                                        : t("unspecified")}
                                  </b>
                                </b>
                              </b>
                            </p>
                          </div>
                          <hr className="m-0 p-0" />
                          <div className="d-flex justify-content-between w-100 p-1-2-3">
                            <p className="m-0">{t("size")} :</p>
                            <p className="m-0 text-success">
                              <b>
                                {typeof product?.options?.size === "object" &&
                                !Array.isArray(product?.options?.color)
                                  ? Object.entries(product?.options?.size)
                                      .length > 0
                                    ? Object.entries(
                                        product?.options?.size,
                                      ).map(([key, value]) => (
                                        <span key={key}>
                                          {key}:{" "}
                                          {Array.isArray(value)
                                            ? value.join(", ")
                                            : value}
                                          <br />
                                        </span>
                                      ))
                                    : t("unspecified")
                                  : typeof product?.options?.size === "string"
                                    ? product?.options?.size.trim() === ""
                                      ? t("unspecified")
                                      : product?.options?.size
                                    : t("unspecified")}
                              </b>
                            </p>
                          </div>
                          <hr className="m-0 p-0" />
                          <div className="d-flex justify-content-between w-100 p-1-2-3">
                            <p className="m-0">{t("quantity")}:</p>
                            <p className="m-0 text-success">
                              <b>{product.quantity}</b>
                            </p>
                          </div>
                          <hr className="m-0 p-0" />

                          <div className="d-flex justify-content-between w-100 p-1-2-3">
                            <p className="m-0">{t("sku")} :</p>
                            <p className="m-0 text-success">
                              <b>{product?.sku || t("unspecified")}</b>
                            </p>
                          </div>
                        </div>
                      </div>

                      <span
                        className="absolute top-0 left-0 p-1 "
                        style={{
                          backgroundColor: "rgba(69, 167, 77, 0)",
                          marginTop: "-11px",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <i
                          onClick={(e) => {
                            data.products.length !== 1
                              ? onDelete(product)
                              : handleDelete(data);
                          }}
                          className="bi bi-x-circle"
                          style={{ color: "red", fontSize: "18px" }}
                        ></i>
                      </span>
                    </div>
                  ))}
                </ul>
              ) : (
                <ul>
                  <div className="max-w-2xl mx-auto py-0 md:px-8">
                    <div className="d-flex justify-content-between w-100 p-1-2 border4">
                      <li className="flex gap-4 items-center">
                        <img
                          src={data.image ? data.image : "/product-foorweb.png"}
                          className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                        />
                        <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                          {data.nameproduct}
                        </div>
                        <span className="text-sm">
                          {data.total - data.deliveryPrice} {localizedCurrency}
                        </span>
                      </li>
                    </div>
                  </div>
                </ul>
              )}
            </>
          ) : data.products ? (
            <ul>
              {data?.nameproduct
                ? productsToShow.map((product) => (
                    <div
                      className="max-w-2xl mx-auto py-0 md:px-8"
                      key={product?.id}
                    >
                      <div className="d-flex justify-content-between w-100 p-1-2 border4">
                        <li className="flex gap-4 items-center">
                          <img
                            src={
                              product?.image
                                ? product?.image
                                : "/product-foorweb.png"
                            }
                            className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                          />
                          <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                            {product?.name}
                          </div>
                          <span className="text-sm">
                            {product?.price} {localizedCurrency}
                          </span>
                        </li>
                      </div>
                    </div>
                  ))
                : data.products.map((product, index) => (
                    <div className="max-w-2xl mx-auto py-0 md:px-8">
                      <div className="d-flex justify-content-between w-100 p-1-2 border4">
                        <li className="flex gap-4 items-center">
                          <img
                            src={
                              product.image
                                ? product.image
                                : "/product-foorweb.png"
                            }
                            className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                          />
                          <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                            {product.name}
                          </div>
                          <span className="text-sm">
                            {data.total - data.deliveryPrice}{" "}
                            {localizedCurrency}
                          </span>
                        </li>
                      </div>
                    </div>
                  ))}
            </ul>
          ) : (
            <ul>
              <div className="d-flex justify-content-between w-100 p-1-2 border4">
                <li className="flex gap-4 items-center">
                  <img
                    src={product ? product.image : "/product-foorweb.png"}
                    className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                  />
                  <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                    {product ? product.name : ""}
                  </div>
                  <span className="text-sm">
                    {data.total} {localizedCurrency}
                  </span>
                </li>
              </div>
            </ul>
          )}
        </div>

        <div className="mt-2 dark:text-gray-300">
          <p className="text-gray-600 text-sm font-semibold sm:text-xs dark:text-gray-300">
            {t("orders.datatable_templating_demo.order_status_updates")}:
          </p>
          <div
            className="flex items-center gap-1"
            style={{
              overflowX: "auto",
              whiteSpace: "nowrap",
              paddingBottom: "20px",
            }}
          >
            {data.statusTimeline ? (
              data.statusTimeline.map((statusUpdate, idx) => (
                <div
                  key={idx}
                  className="flex items-center gap-1 flex-shrink-0"
                >
                  {idx > 0 && (
                    <img
                      src="https://cdn-icons-png.flaticon.com/128/3575/3575967.png"
                      alt="→"
                      className="w-3 h-3 flex-shrink-0"
                    />
                  )}
                  <div
                    className="flex items-center gap-0.5"
                    title={`${statusUpdate.ownby ? statusUpdate.ownby : ""}${
                      statusUpdate.ownby && statusUpdate.timestamp ? " • " : ""
                    }${
                      statusUpdate.timestamp
                        ? statusUpdate.timestamp.seconds
                          ? new Date(
                              statusUpdate.timestamp.seconds * 1000,
                            ).toLocaleString("ar-DZ", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                          : new Date(statusUpdate.timestamp).toLocaleString(
                              "ar-DZ",
                              {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                              },
                            )
                        : ""
                    }`}
                  >
                    <img
                      src={
                        statusUpdate.status === "1"
                          ? "https://cdn-icons-png.flaticon.com/512/10608/10608900.png"
                          : statusUpdate.status === "2"
                            ? "https://cdn-icons-png.flaticon.com/128/1688/1688988.png"
                            : statusUpdate.status === "9"
                              ? "https://cdn-icons-png.flaticon.com/128/1688/1688988.png"
                              : statusUpdate.status === "3"
                                ? "https://cdn-icons-png.flaticon.com/128/6815/6815043.png"
                                : statusUpdate.status === "4"
                                  ? "https://cdn-icons-png.flaticon.com/128/1559/1559859.png"
                                  : statusUpdate.status === "5"
                                    ? "https://cdn-icons-png.flaticon.com/128/6815/6815043.png"
                                    : statusUpdate.status === "6"
                                      ? "https://cdn-icons-png.flaticon.com/128/391/391247.png"
                                      : statusUpdate.status === "6-1"
                                        ? "https://cdn-icons-png.flaticon.com/128/595/595067.png"
                                        : statusUpdate.status === "6-2"
                                          ? "/order6-2.png"
                                          : statusUpdate.status === "6-3"
                                            ? "https://cdn-icons-png.flaticon.com/128/1828/1828843.png"
                                            : statusUpdate.status === "6-4"
                                              ? "https://cdn-icons-png.flaticon.com/128/2882/2882188.png"
                                              : statusUpdate.status === "10"
                                                ? "https://cdn-icons-png.flaticon.com/128/2933/2933116.png"
                                                : statusUpdate.status === "11-1"
                                                  ? "https://cdn-icons-png.flaticon.com/128/2593/2593514.png"
                                                  : statusUpdate.status ===
                                                      "11-2"
                                                    ? "https://cdn-icons-png.flaticon.com/128/9946/9946401.png"
                                                    : statusUpdate.status ===
                                                        "11-3"
                                                      ? "../agenda.png"
                                                      : statusUpdate.status ===
                                                          "11-4"
                                                        ? "https://cdn-icons-png.flaticon.com/128/8402/8402548.png"
                                                        : statusUpdate.status ===
                                                            "11-5"
                                                          ? "https://cdn-icons-png.flaticon.com/128/7787/7787073.png"
                                                          : "https://cdn-icons-png.flaticon.com/128/11442/11442042.png"
                      }
                      className="w-8 h-8 flex-shrink-0"
                      alt=""
                    />
                    {statusUpdate.recordingUrl && (
                      <AudioAffichage
                        recordingUrl={statusUpdate.recordingUrl}
                        size={30}
                      />
                    )}
                  </div>
                </div>
              ))
            ) : (
              <p className="text-gray-700 text-center dark:text-gray-400 mx-auto">
                {t("orders.datatable_templating_demo.no_Update")}
              </p>
            )}
          </div>
        </div>
        <div>
          <h4 className=" font-semibold sm:text-lg dark:text-gray-300">
            {t("orders.datatable_templating_demo.receive_order")}
          </h4>
          <p className="text-[#9e68ba]">{formattedDate}</p>
        </div>
        <div className="mt-2 grid gap-8 sm:grid-cols-2 lg:grid-cols-2">
          <div className=" justify-content-between w-100 p-1-2 border4 dark:!border-[#3c3a3d]">
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.full_name")} :{" "}
              </p>
              <p className="m-0 text-success">
                <b>{data.name}</b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.phone_number")} :{" "}
              </p>
              <p className="m-0 text-success">
                <b>
                  {" "}
                  {shouldShowLockedContent(data) ? (
                    <i
                      className="fs-3"
                      onClick={() => handleLockedContentClick(data)}
                    >
                      <img src={"/lock.png"} className="mx-auto" />
                    </i>
                  ) : (
                    <a
                      href={`tel:${data.phone}}`}
                      style={{ textDecoration: "none" }}
                    >
                      {data.phone}
                    </a>
                  )}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.full_address")} :{" "}
              </p>
              <p className="m-0 text-success">
                <b>
                  {data.state}.{data.commune}.{data.address}{" "}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.customer_note")} :{" "}
              </p>
              <p className="m-0 text-success">
                <b>
                  {data?.note?.trim() !== "" || data?.options?.trim() !== ""
                    ? data?.note?.trim() || data?.options?.trim()
                    : t("orders.datatable_templating_demo.no_note")}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.ip_address")} :
              </p>
              <p className="m-0 text-success">
                <b>{data.ipAddress ? data.ipAddress : "-"}</b>
              </p>
            </div>
          </div>

          <div className=" justify-content-between w-100 p-1-2 border4 dark:!border-[#3c3a3d]">
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.product_value")} :
              </p>
              <p className="m-0 text-success">
                <b>
                  {data.total -
                    (data.deleveryPrice
                      ? data.deleveryPrice
                      : data.deliveryPrice)}{" "}
                  {localizedCurrency}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.quantity")} :
              </p>
              <p className="m-0 text-success">
                <b> {data.qty} </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.delivery_fees")} :
              </p>
              <p className="m-0 text-success">
                <b>
                  {data.deleveryPrice ? data.deleveryPrice : data.deliveryPrice}{" "}
                  {localizedCurrency}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.grand_total")} :
              </p>
              <p className="m-0 text-success">
                <b>
                  {data.total} {localizedCurrency}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={() => addIpToAdressipblock(data)}
              >
                {t("orders.datatable_templating_demo.block")}
              </button>
              <button
                type="button"
                className="btn btn-outline-warning"
                onClick={() => removeIpFromAdressipblock(data)}
              >
                {t("orders.datatable_templating_demo.delete")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleDelete = async (data) => {
    Swal.fire({
      title: t("ship.confirm_delete"),
      html: `
        <p>هل أنت متأكد من القيام بذلك؟</p>
        <small style="display:block;margin-top:10px;color:gray;">
          تحذير : إذا أنت في حالة المحذوفة  سيتم حذف الطلب نهائيا.
        </small>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "rgb(141, 93, 167)",
      cancelButtonColor: "#e87778",
      confirmButtonText: t("ship.yes"),
      cancelButtonText: t("ship.no"),
    }).then((result) => {
      if (result.isConfirmed) {
        const audio = new Audio("/Mouth woosh_42.wav");
        audio.play();

        if (data.deleveryStatus === "8") {
          const deletedOrder = { ...data, deleted: 1 };
          setDoc(doc(db, "orders", data.id), deletedOrder).then(() => {
            onDelete(data.id);
          });
        } else {
          const movedOrder = { ...data, deleveryStatus: "8" };
          setDoc(doc(db, "orders", data.id), movedOrder).then(() => {
            onStatusChange(data.id, movedOrder);
          });
        }
      }
    });
  };

  const navigate = useNavigate();

  const navigateToOrder = (rowData) => {
    if (rowData && rowData.id) {
      navigate(`/orderProfile/${rowData.id}`, {
        state: {
          orderData: rowData,
          filteredOrderIds: orders.map((o) => o.id),
          productData: productdata.find(
            (product) => product.id === rowData.productId,
          ),
        },
      });
    } else {
      console.error("Order ID not found!");
    }
  };

  const handleUpdate = async (rowData) => {
    setData(rowData);
    setLgShow(true);
  };

  const actionTemplate = (rowData) => {
    const commercantNote = !!rowData?.commercantNote;

    return (
      <div className="flex items-center flex-col">
        {commercantNote && (
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={`note-tooltip-${rowData.id}`}>
                {rowData.commercantNote}
              </Tooltip>
            }
          >
            <button
              type="button"
              className="bot1 dark:bg-[#181919] dark:!text-gray-300 p-1"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/4611/4611672.png"
                alt={t("orders.note")}
                className="w-5 h-5"
              />
            </button>
          </OverlayTrigger>
        )}

        <Dropdown
          overlay={
            <Menu className="">
              <Menu.Item
                key="1"
                className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss bi "
                size={16}
                onClick={
                  !!account.store
                    ? () =>
                        guardLockedAction(rowData, () => handleUpdate(rowData))
                    : () => {
                        message();
                      }
                }
              >
                <i
                  style={{
                    display: "flex",
                    textAlign: "center",
                    paddingRight: "2px",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-file-pen-line hover:text-green-500 ml-2"
                  >
                    <path d="m18 5-2.414-2.414A2 2 0 0 0 14.172 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2" />
                    <path d="M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z" />
                    <path d="M8 18h1" />
                  </svg>
                  {t("orders.datatable_templating_demo.edit")}
                </i>
              </Menu.Item>
              <Menu.Item
                key={rowData.id}
                className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss  hover:text-green-500"
                size={16}
                onClick={() =>
                  guardLockedAction(rowData, () => navigateToOrder(rowData))
                } // Pass the entire rowData
              >
                <i
                  style={{
                    display: "flex",
                    textAlign: "center",
                    paddingRight: "2px",
                    alignItems: "center",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-eye ml-2 hover:text-green-500"
                  >
                    <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                  {t("orders.datatable_templating_demo.preview")}
                </i>
              </Menu.Item>

              <Menu.Item
                key="3"
                className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 "
                size={16}
                onClick={
                  !!account.store
                    ? () => {
                        handleDelete(rowData);
                      }
                    : () => {
                        message();
                      }
                }
              >
                <i
                  style={{
                    color: "#f21919",
                    display: "flex",
                    textAlign: "center",
                    paddingRight: "2px",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#f21919"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="lucide lucide-trash2-icon lucide-trash-2 ml-2"
                  >
                    <path d="M3 6h18" />
                    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                    <line x1="10" x2="10" y1="11" y2="17" />
                    <line x1="14" x2="14" y1="11" y2="17" />
                  </svg>
                  {t("orders.datatable_templating_demo.delete")}
                </i>
              </Menu.Item>
            </Menu>
          }
        >
          <button className="bot1 dark:bg-[#181919] dark:!text-gray-300 p-1">
            <Edit className="w-5 h-5" />
          </button>
        </Dropdown>
      </div>
    );
  };
  const groubeUpdates = async (data) => {
    const batch = writeBatch(db);
    const telegramBotToken = "6672968395:AAHFokejZq4r6GRRDHlm2FDqXk0-pXoQmOs";
    const chatId = store.Idtelegram;
    const allMessage = `📢 تم تغيير حالات طلباتك بشكل جماعي. تفقد متجرك للاطلاع على المستجدات وتحديثات الطلبات. 🛍️💼`;
    setIsMultiple(true);

    // Not-paid orders can't be modified in bulk either — drop them from the
    // batch instead of letting a full-document write touch them.
    const lockedCount = selectedProducts.filter((order) =>
      shouldShowLockedContent(order),
    ).length;
    const selectedProducts_ = selectedProducts.filter(
      (order) => !shouldShowLockedContent(order),
    );
    if (lockedCount > 0) {
      Swal.fire({
        icon: "warning",
        title: t("ui.someOrdersLocked"),
        text: t("ui.lockedOrdersSkipped", { value0: lockedCount }),
        confirmButtonText: t("adduser.ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    }
    if (selectedProducts_.length === 0) {
      setIsMultiple(false);
      return;
    }

    if (deleveryCompany !== "") {
      const normalOrders = selectedProducts_.filter(
        (order) => !order.stopdeskDelivery,
      );
      const stopdeskOrders = selectedProducts_.filter(
        (order) => order.stopdeskDelivery,
      );

      try {
        if (normalOrders.length > 0) {
          const normalPromises = normalOrders.map((order) =>
            changeShip(order, deleveryCompany).catch((error) => ({
              order,
              error: error.message,
            })),
          );

          const normalResults = await Promise.allSettled(normalPromises);

          normalResults.forEach((result, index) => {
            if (result.status === "rejected" || result.value?.error) {
              console.error(
                `Erreur commande normale ${normalOrders[index].id}:`,
                result.reason || result.value.error,
              );
            }
          });
        }

        if (stopdeskOrders.length > 0) {
          await processStoredeskOrders(stopdeskOrders);
        }

        if (normalOrders.length > 0 || stopdeskOrders.length > 0) {
          axios
            .post(
              `https://api.telegram.org/bot${telegramBotToken}/sendMessage`,
              {
                chat_id: chatId,
                text: allMessage,
              },
            )
            .catch((error) =>
              console.error("Erreur notification Telegram:", error),
            );
        }
      } catch (error) {
        console.error("Erreur lors du traitement des commandes:", error);
        Swal.fire({
          title: t("ui.processingError"),
          text: t("ui.ordersProcessingError"),
          icon: "error",
        });
      }
    }

    // Traitement des mises à jour de statut en lot
    if (bluck !== "") {
      if (bluck === "7") {
        selectedProducts_.forEach((order) => {
          const sfRef = doc(db, "orders", order.id);
          batch.set(sfRef, { ...order, deleted: 1 });
          // Mettre à jour le state local
          onStatusChange(order.id, { ...order, deleted: 1 });
        });
      }

      try {
        if (bluck === "7") {
          await batch.commit();
        } else {
          for (const order of selectedProducts_) {
            await changeStatus(order, bluck, { skipTelegram: true });
          }
        }

        axios
          .post(`https://api.telegram.org/bot${telegramBotToken}/sendMessage`, {
            chat_id: chatId,
            text: allMessage,
          })
          .catch((error) =>
            console.error("Erreur notification Telegram:", error),
          );

        if (bluck === "7") {
          Swal.fire({
            title: t("ui.deletedSuccessfully"),
            icon: "success",
            confirmButtonText: t("ship.yes"),
            confirmButtonColor: "rgb(141, 93, 167)",
          });
        }
      } catch (error) {
        Swal.fire({
          title: t("foorAi.history.error.generic"),
          text: t("FormSettings.alerts.save_error.text"),
          icon: "error",
        });
      }
    }
  };

  const processStoredeskOrders = async (stopdeskOrders) => {
    return new Promise((resolve) => {
      let currentIndex = 0;
      const results = [];

      const processNext = async () => {
        if (currentIndex >= stopdeskOrders.length) {
          resolve(results);
          return;
        }

        const currentOrder = stopdeskOrders[currentIndex];

        try {
          const result = await changeShip(currentOrder, deleveryCompany);
          results.push({ order: currentOrder, success: true, result });
        } catch (error) {
          results.push({
            order: currentOrder,
            success: false,
            error: error.message,
          });
          console.error(
            `Erreur commande stopdesk ${currentOrder.id}:`,
            error.message,
          );
        }

        currentIndex++;

        setTimeout(processNext, 500);
      };

      processNext();
    });
  };

  const selectTemplate = (rowData) => {
    return (
      <div>
        <Form.Check
          type={"checkbox"}
          checked={selectedProducts.map((p) => p.id).includes(rowData.id)}
          onChange={() => {
            !selectedProducts.map((p) => p.id).includes(rowData.id)
              ? setSelectedProducts([...selectedProducts, rowData])
              : setSelectedProducts(
                  selectedProducts.filter((p) => p.id !== rowData.id),
                );
          }}
        />
      </div>
    );
  };

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const htmlToPdfBytes = async (element) => {
    return new Promise((resolve) => {
      const opt = {
        margin: 0,
        filename: "fallback.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
      };

      html2pdf()
        .set(opt)
        .from(element)
        .outputPdf("arraybuffer")
        .then((pdfBytes) => {
          resolve(pdfBytes);
        });
    });
  };

  const handleDownloadAndPrintLabels = async () => {
    const mergedPdf = await PDFDocument.create();
    const apiPrintedTrackings = new Set();

    for (const product of selectedProducts) {
      try {
        let response;

        switch (product.DC) {
          case "3":
            response = await fetch(
              `${store?.Uecotrack}/api/v1/get/order/label?api_token=${store?.Ecotrack}&tracking=${product.tracking}`,
              {
                method: "GET",
              },
            );
            break;

          case "1":
            const ord = JSON.stringify({
              orders_ids: [product.display_id_order || product.tracking],
            });

            response = await fetch(
              "https://backend.maystro-delivery.com/api/delivery/starter/starter_bordureau/",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Token ${store?.Maystro}`,
                },
                body: ord,
              },
            );
            break;

          case "16":
            // Handle ZR Express case
            break;

          default:
            const transformed = {
              data: [
                {
                  tracking: product.tracking || "",
                  weight: product.weight || "1.0",
                  stopdeskDelivery: product.stopdeskDelivery,
                  total: product.total,
                  name: product.name,
                  phone: shouldShowLockedContent(product)
                    ? "**********"
                    : product.phone,
                  state: product.state,
                  commune: product.commune,
                  address: product.address || "العنوان غير محدد",
                  qty: product.qty,
                  productId: product.products?.[0]?.id || product.id,
                  deliveryPrice: product.deliveryPrice,
                  nameproduct:
                    product.products?.[0]?.name || "المنتج غير معروف",
                },
              ],
              account: {
                name: account.name,
                phone: account.phone,
              },
              logo:
                store.logo || "https://admin.foorweb.store/LogoVersionAr.png",
              products:
                product.products?.map((p) => ({
                  id: p.id,
                  name: p.name,
                  size: p.options?.size || "",
                  color: p.options?.color || "",
                })) || [],
            };
            //droplet digital ocean not off
            response = await fetch(
              "https://backend.foorweb.store/api/createPdf",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(transformed, null, 2),
              },
            );
            const responseTextPreview = await response.clone().text();
            console.log(
              "RESPONSE TEXT PREVIEW:",
              responseTextPreview.slice(0, 120),
            );
            break;
        }

        if (!response || !response.ok) {
          console.error(
            `erreur HTTP ${response?.status} pour ${product.tracking}`,
          );
          continue;
        }

        const pdfBytes = await response.arrayBuffer();
        const singlePdf = await PDFDocument.load(pdfBytes);
        const copiedPages = await mergedPdf.copyPages(
          singlePdf,
          singlePdf.getPageIndices(),
        );
        copiedPages.forEach((page) => mergedPdf.addPage(page));

        apiPrintedTrackings.add(product.tracking);
      } catch (error) {
        console.error(`Erreur produit ${product.tracking} :`, error);
        continue;
      }
    }

    // 📦 Générer le PDF final fusionné
    const mergedPdfBytes = await mergedPdf.save();
    const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
    const blobURL = URL.createObjectURL(blob);

    // 🖨️ Impression via iframe
    const iframe = document.getElementById("pdfPrinter");
    if (iframe) {
      iframe.src = blobURL;
      iframe.onload = () => {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      };
    } else {
      console.error("Iframe pdfPrinter introuvable dans le DOM.");
    }
  };

  const handleLabels = async () => {
    handleDownloadAndPrintLabels();
  };

  let isFunctionRunning = false;

  const handlePay = async (rowData) => {
    // إذا كانت الدالة تعمل بالفعل، فلا تقوم بتنفيذها مرة أخرى
    if (isFunctionRunning) {
      return;
    }

    isFunctionRunning = true; // تعيين المتغير إلى true للإشارة إلى أن الدالة تعمل حاليًا

    const isOnline = navigator.onLine;

    if (!isOnline) {
      // رسالة عندما لا يكون هناك اتصال بالإنترنت
      Swal.fire({
        icon: "error",
        title: t("ship.no_internet"),
        text: t("orderDetails.alerts.internet.text"),
        confirmButtonText: t("orders.datatable_templating_demo.okay"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      isFunctionRunning = false; // استعادة المتغير إلى false بمجرد انتهاء الدالة
      return;
    }

    try {
      const nextAccount = await consumeSubscriptionToken({
        accountId: account?.id,
      });

      const updatedOrder = { ...rowData, isValid: false };

      await updateDoc(doc(db, "orders", rowData?.id), {
        isValid: false,
      });

      // Mettre à jour le state local
      onStatusChange(rowData?.id, updatedOrder);

      dispatch(fetchAccount(nextAccount));
      dispatch(
        fetchOrders(
          ordersState.map((order) =>
            order.id === rowData?.id ? { ...order, isValid: false } : order,
          ),
        ),
      );

      isFunctionRunning = false;
    } catch (error) {
      console.error("Error while processing payment:", error);

      if (error?.code === "INSUFFICIENT_TOKENS") {
        Swal.fire({
          icon: "error",
          title: t("ship.insufficient_balance"),
          text: t("ship.insufficient_balance_message"),
          confirmButtonText: t("ship.recharge_balance"),
          confirmButtonColor: "rgb(141, 93, 167)",
          showCancelButton: true,
          cancelButtonText: t("annule"),
          cancelButtonColor: "#e87778",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = "/plan";
          }
          isFunctionRunning = false;
        });
        return;
      }

      Swal.fire({
        icon: "error",
        title: t("orders.datatable_templating_demo.error"),
        text: t("ui.paymentProcessingError"),
        confirmButtonText: t("orders.datatable_templating_demo.okay"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      isFunctionRunning = false;
    }
  };

  const notPaidTemplate = (rowData) => {
    // Get fresh data from Redux cache
    const currentData = ordersState.find((o) => o.id === rowData.id) || rowData;

    return (
      <div>
        {shouldShowLockedContent(currentData) ? (
          <i
            className="fs-3"
            onClick={() => handleLockedContentClick(currentData)}
          >
            <img
              src={"/lock.png"}
              className="mx-auto"
              alt={t("orderDetails.top_section.image_alt")}
            />
          </i>
        ) : (
          <PhoneActionMenu phone={currentData.phone} />
        )}
      </div>
    );
  };

  const wilaya1 = (rowData) => {
    return (
      <div>{<a style={{ textDecoration: "none" }}>{rowData.state}</a>}</div>
    );
  };

  const imageBodyTemplate = (rowData) => {
    let productsToShow = [];
    const product = productdata.find(
      (product) => product.id === rowData.productId,
    );
    const getProductImageFromCatalog = (
      productRef,
      fallbackImage = "/product-foorweb.png",
    ) => {
      const refSku =
        (typeof productRef === "object" ? productRef?.sku : "") || "";
      const refName =
        (typeof productRef === "object" ? productRef?.name : "") || "";
      const refImage =
        (typeof productRef === "object" ? productRef?.image : "") || "";

      const normalize = (value) =>
        String(value || "")
          .trim()
          .toLowerCase();

      const catalogProduct = productdata.find((item) => {
        if (refSku && normalize(item?.sku) === normalize(refSku)) return true;
        if (refName && normalize(item?.name) === normalize(refName))
          return true;
        if (refImage) {
          return (
            normalize(item?.image) === normalize(refImage) ||
            normalize(item?.newImage) === normalize(refImage)
          );
        }
        return false;
      });

      return (
        catalogProduct?.newImage ||
        catalogProduct?.image ||
        refImage ||
        fallbackImage
      );
    };
    if (rowData.products && rowData.products.length > 0) {
      productsToShow = rowData.products
        .slice(0, 2)
        .map((p) => productdata.find((product) => product.id === p.id));
    }

    return rowData?.products ? (
      <div
        onClick={() => navigateToOrder(rowData)}
        state={{
          from: { ...rowData },
          product: productdata.find(
            (product) => product.id === rowData.productId,
          ),
          products: productsToShow,
        }}
      >
        <div
          className={`flex overflow-hidden ${
            isRTL === "ltr"
              ? "-space-x-2 flex-row-reverse"
              : "-space-x-2 -space-x-reverse"
          }`}
        >
          {rowData.products.slice(0, 2).map((product, index) => (
            <div className="relative">
              {rowData?.hasUsedCrossSell && index === 0 && (
                <img
                  src="/crossellBadge.png"
                  alt={t("ui.sale")}
                  className="absolute top-0"
                  style={{
                    right: window.innerWidth <= 768 ? "1px" : "1px",
                    zIndex: 50,
                    maxWidth: window.innerWidth <= 768 ? "18px" : "20px",
                  }}
                />
              )}

              <div key={index} className="relative">
                <img
                  src={getProductImageFromCatalog(product, product?.image)}
                  height="75px"
                  alt={product?.name}
                  className={`rounded-lg overflow-hidden shadow-sm border-2  w-14 h-14 bg-[#faf1ff] z-30 avatar${
                    index + 1
                  }`}
                  style={{
                    border: rowData?.stayOffer
                      ? "2px solid #e91b24"
                      : rowData?.isImaginary
                        ? "2px solid #ffb400"
                        : "2px solid white",
                  }}
                />
              </div>

              {rowData.isImaginary && (
                <img
                  src="/euror.png"
                  alt="559384"
                  className="absolute bottom-0 "
                  style={{
                    right: window.innerWidth <= 768 ? "27px" : "32px",
                    zIndex: 0,
                    maxWidth: window.innerWidth <= 768 ? "21px" : "22px",
                  }}
                />
              )}
              {rowData.platform === "tiktok" && (
                <img
                  src="/tiktok.png" // حط لوجو تيك توك هنا
                  alt={t("navbar.try.tiktok")}
                  className="absolute top-0 right-0"
                  style={{
                    right: window.innerWidth <= 768 ? "0px" : "0px",
                    zIndex: 0,
                    maxWidth: window.innerWidth <= 768 ? "21px" : "22px",
                  }}
                />
              )}

              {rowData.platform === "foorchat" && (
                <img
                  src="/foorchat.gif" // حط لوجو تيك توك هنا
                  alt="foorchat"
                  className="absolute top-0 right-0"
                  style={{
                    right: window.innerWidth <= 768 ? "0px" : "0px",
                    zIndex: 0,
                    maxWidth: window.innerWidth <= 768 ? "40px" : "35px",
                  }}
                />
              )}

              {rowData.platform === "facebook" && (
                <img
                  src="/metaa.png" // حط لوجو ميتا/فيسبوك هنا
                  alt="Meta"
                  className="absolute top-0 left-0"
                  style={{
                    right: window.innerWidth <= 768 ? "0px" : "0px",
                    zIndex: 0,
                    maxWidth: window.innerWidth <= 768 ? "21px" : "22px",
                  }}
                />
              )}
            </div>
          ))}

          {rowData.products.length > 2 ? (
            <div className="relative">
              <div className="absolute top-0 left-0 text-white w-5 h-5 flex items-center justify-center rounded-full  bg-[#9b59bf] pt-1">
                {rowData.products.length > 2
                  ? `${rowData.products.length - 2}+`
                  : ""}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    ) : (
      <>
        {rowData.nameproduct ? (
          <Link
            to={`/orderProfile/${rowData.id}`}
            state={{
              orderData: rowData,
              filteredOrderIds: orders.map((o) => o.id),
            }}
          >
            <div className="flex -space-x-2 overflow-hidden">
              <div className="relative">
                <img
                  src={getProductImageFromCatalog(
                    {
                      id: rowData.productId,
                      name: rowData.nameproduct,
                      image: rowData.image,
                      sku: rowData.sku,
                    },
                    rowData.image,
                  )}
                  height="75px"
                  alt={rowData.nameproduct ? rowData.nameproduct : ""}
                  className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff] avatar2"
                />
              </div>
            </div>
          </Link>
        ) : (
          <Link
            to={`/orderProfile/${rowData.id}`}
            state={{
              orderData: rowData,
              filteredOrderIds: orders.map((o) => o.id),
              product: productdata.find(
                (product) => product.id === rowData.productId,
              ),
              products: productdata,
            }}
          >
            <div className="flex -space-x-2 overflow-hidden">
              <div className="relative">
                <img
                  src={getProductImageFromCatalog(
                    {
                      id: rowData.productId,
                      name: product?.name || rowData.nameproduct,
                      image: product?.image || rowData.image,
                      sku: product?.sku || rowData.sku,
                    },
                    product?.image || rowData.image,
                  )}
                  height="75px"
                  alt={product ? product.name : ""}
                  className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff] avatar2"
                />
              </div>
            </div>
          </Link>
        )}
      </>
    );
  };
  const hasValidOrders = selectedProducts.some(
    (product) => product.isValid === true,
  );

  const [showOptions, setShowOptions] = useState(false);

  /*--------------------------------------- زر الحالات -----------------------------------------------*/
  const getUniqueDaysCount = (statusTimeline) => {
    if (!Array.isArray(statusTimeline)) return 0;

    const uniqueDates = new Set();

    statusTimeline.forEach((item) => {
      if (item.timestamp) {
        let timestamp = item.timestamp;

        // Validate timestamp and ensure it's a valid date
        if (timestamp.seconds) {
          timestamp = new Date(timestamp.seconds * 1000);
        } else if (isNaN(new Date(timestamp))) {
          return; // Skip invalid timestamp
        } else {
          timestamp = new Date(timestamp); // fallback
        }

        const dayString = timestamp.toISOString().split("T")[0]; // YYYY-MM-DD
        uniqueDates.add(dayString);
      }
    });

    return uniqueDates.size;
  };

  const checkAndUpdateStatusAtMidnight = async (order) => {
    // Vérifier si le nombre de tentatives est >= 3
    const tentativesCount = getUniqueDaysCount(order.statusTimeline);

    if (tentativesCount >= 3) {
      // Vérifier si c'est minuit (entre 00:00 et 00:01)
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();

      if (hours === 0 && minutes <= 1) {
        // Fenêtre de 1 minute après minuit
        // Vérifier si la dernière mise à jour n'a pas déjà été faite aujourd'hui
        const lastUpdate = order.lastStatusUpdate
          ? new Date(order.lastStatusUpdate.seconds * 1000)
          : null;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (!lastUpdate || lastUpdate < today) {
          const updatedOrder = {
            ...order,
            deleveryStatus: "6-4",
            lastStatusUpdate: new Date(),
            statusTimeline: [
              ...(order.statusTimeline || []),
              {
                status: "6-4",
                timestamp: new Date(),
                ownby: "Automatique",
              },
            ],
          };

          await setDoc(doc(db, "orders", order.id), updatedOrder);

          // Mettre à jour le state local
          onStatusChange(order.id, updatedOrder);

          // Synchroniser vers Redux
          dispatch(
            fetchOrders([
              ...ordersState.map((o) => (o.id === order.id ? updatedOrder : o)),
            ]),
          );
        }
      }
    }
  };

  const combinedTemplate = (rowData) => {
    // Chercher les données à jour du Redux pour avoir l'état le plus récent quand on change le statut
    const currentData = ordersState.find((o) => o.id === rowData.id) || rowData;
    const deleveryStatus = currentData.deleveryStatus;

    const statusColor = statusBodyTemplate(currentData);
    const tentativesCount = getUniqueDaysCount(currentData.statusTimeline);
    let text = null;
    let buttonImage =
      "https://cdn-icons-png.flaticon.com/512/10608/10608900.png"; // الصورة الافتراضية
    const assignedId = currentData?.assignedConfirmerId;
    const confirmer = assignedId
      ? confirmers.find(
          (c) =>
            c.id === assignedId ||
            c.user === assignedId ||
            c.uid === assignedId,
        )
      : null;
    const confirmerPhoto = confirmer?.photoUrl;
    const confirmerInitial =
      confirmer?.name?.charAt(0) ||
      confirmer?.fullName?.charAt(0) ||
      confirmer?.email?.charAt(0) ||
      "?";

    if (deleveryStatus === "1") {
      buttonImage = "https://cdn-icons-png.flaticon.com/512/10608/10608900.png";
    } else if (deleveryStatus === "2") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/1688/1688988.png";
    } else if (deleveryStatus === "9") {
      buttonImage = "/8888205.png";
    } else if (deleveryStatus === "3") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/8888/8888205.png";
    } else if (deleveryStatus === "4") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/1559/1559859.png";
    } else if (deleveryStatus === "5") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/6815/6815043.png";
    } else if (
      deleveryStatus === "6" ||
      deleveryStatus === "6-3" ||
      deleveryStatus === "6-4"
    ) {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/391/391247.png";
    } else if (deleveryStatus === "6-1") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/595/595067.png";
    } else if (deleveryStatus === "6-2") {
      buttonImage = "/order6-2.png";
    } else if (deleveryStatus === "11-1") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/2593/2593514.png";
    } else if (deleveryStatus === "11-2") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/9946/9946401.png";
      // إذا تم اختيار إرسال إلى شركة الشحن
      if (currentData.DC === "1") {
        buttonImage = "https://cdn-icons-png.flaticon.com/128/9946/9946401.png";
      }
    } else if (deleveryStatus === "11-3") {
      buttonImage = "../agenda.png";
    } else if (deleveryStatus === "11-4") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/8402/8402548.png";
    } else if (deleveryStatus === "11-5") {
      buttonImage = "https://cdn-icons-png.flaticon.com/128/7787/7787073.png";
    } else if (deleveryStatus === "10") {
      buttonImage = "https://cdn-icons-png.flaticon.com/512/11153/11153363.png";
    }

    const shippingOptions = [];
    if (!!store.Maystro) shippingOptions.push({ value: "1", label: "Maystro" });
    if (!!store.Zrexpress)
      shippingOptions.push({ value: "2", label: "Zr express" });
    if (!!store.Ecotrack && !!store.Uecotrack) {
      const isDhdPlatform = isDhdUser && store.Uecotrack === DHD_PLATFORM_URL;

      shippingOptions.push({
        value: "3",
        label: isDhdPlatform ? "DHD" : "Ecotrack",
      });
    }
    if (!!store.Userguid && !!store.ApitokenNord)
      shippingOptions.push({ value: "4", label: "Nord Et Ouest" });
    if (!!store.YalidineW && !!store.Yalidinetoken && !!store.Yalidineid)
      shippingOptions.push({ value: "5", label: "Yalidine" });
    if (!!store.UserguidGuepex && !!store.Apitokenguepex)
      shippingOptions.push({ value: "6", label: "Guepex" });
    if (!!store.apielogistia)
      shippingOptions.push({ value: "7", label: "elogistia" });
    if (!!store.zimouToken)
      shippingOptions.push({ value: "8", label: "zimou Express" });
    if (!!store.AmeexId) shippingOptions.push({ value: "9", label: "Ameex" });
    if (!!store.mdm_apikey)
      shippingOptions.push({ value: "10", label: "MDM Express" });
    if (!!store.YalitecId)
      shippingOptions.push({ value: "11", label: "Yalitec" });
    if (!!store.coliv_token)
      shippingOptions.push({ value: "12", label: "Colvraison" });
    if (!!store.mylerzToken)
      shippingOptions.push({ value: "13", label: "Mylerz" });
    if (!!store.ecomdelivery_token)
      shippingOptions.push({ value: "14", label: "Ecom Delivery" });
    if (!!store.flashdelivery_key)
      shippingOptions.push({ value: "15", label: "Flash Delivery" });
    if (!!store.zrExpressXTenant_V2)
      shippingOptions.push({ value: "16", label: "Zr Express V2" });
    if (!!store.ecomdeliveryv2_key && !!store.ecomdeliveryv2_token)
      shippingOptions.push({ value: "18", label: "Ecom Delivery V2" });
    // if (!!store.Zrexpress) shippingOptions.push({ value: "8", label: "3Mexpress" });
    if (!!store.OsenToken) shippingOptions.push({ value: "19", label: "OSEN" });

    if (isDhdUser) {
      // dhd users can only send to ecotrack
      const ecotrackOnly = shippingOptions.filter((opt) => opt.value === "3");
      shippingOptions.length = 0;
      shippingOptions.push(...ecotrackOnly);
    }

    return (
      <Dropdown
        overlay={
          <Menu className="dark:bg-[#141414] dark:!text-gray-300 dark:!border-[#3c3a3d]">
            {deleveryStatus !== "5" && (
              <>
                <Menu.Item
                  key="3"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-cart-check dark:!text-gray-300  ${
                    deleveryStatus === "3" ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, "3")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t("orders.datatable_templating_demo.confirmed")}
                  </a>
                </Menu.Item>
                <hr className="m-0 p-0" />
                {store.confirmChat && (
                  <Menu.Item
                    key="9"
                    className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-cart-check dark:!text-gray-300 ${
                      deleveryStatus === "9" ? "selected" : ""
                    }`}
                    onClick={() => changeStatus(rowData, "9")}
                  >
                    <a className="s11 dark:!text-gray-300">
                      {t(
                        "orders.datatable_templating_demo.confirmed_by_customer",
                      )}
                    </a>
                  </Menu.Item>
                )}
                {store.confirmChat && <hr className="m-0 p-0" />}
                <Menu.Item
                  key="11-2"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-telephone-x-fill dark:!text-gray-300 ${
                    deleveryStatus === "11-2" ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, "11-2")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t("orders.datatable_templating_demo.no_response_to_call")}
                  </a>
                </Menu.Item>
                <hr className="m-0 p-0" />
                <Menu.Item
                  key="11-3"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-calendar2-check dark:!text-gray-300${
                    deleveryStatus === "11-3" ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, "11-3")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t("orders.datatable_templating_demo.postponed")}
                  </a>
                </Menu.Item>

                <hr className="m-0 p-0" />
                <Menu.Item
                  key="6"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-x-circle dark:!text-gray-300 ${
                    deleveryStatus === "6" ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, "6")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t("orders.datatable_templating_demo.cancelled")}
                  </a>
                </Menu.Item>
                <hr className="m-0 p-0" />

                <Menu.Item
                  key="6-1"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-exclamation-circle dark:!text-gray-300 ${
                    deleveryStatus === "6-1" ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, "6-1")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t("orders.datatable_templating_demo.fake")}
                  </a>
                </Menu.Item>
                <hr className="m-0 p-0" />

                <Menu.Item
                  key="6-2"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-files dark:!text-gray-300 ${
                    deleveryStatus === "6-2" ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, "6-2")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t("orders.datatable_templating_demo.duplicate")}
                  </a>
                </Menu.Item>
                <hr className="m-0 p-0" />

                <Menu.Item
                  key="11-5"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-person-x dark:!text-gray-300 ${
                    deleveryStatus === "11-5" ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, "11-5")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t(
                      "orders.datatable_templating_demo.cancelled_by_customer",
                    )}
                  </a>
                </Menu.Item>
                <hr className="m-0 p-0" />
                <Menu.Item
                  key="11-1"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-telephone-inbound dark:!text-gray-300 ${
                    deleveryStatus === "11-1" ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, "11-1")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t(
                      "orders.datatable_templating_demo.awaiting_customer_contact",
                    )}
                  </a>
                </Menu.Item>
                <hr className="m-0 p-0" />
                <Menu.Item
                  key="11-4"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-telephone-minus dark:!text-gray-300 ${
                    deleveryStatus === "11-4" ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, "11-4")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t("orders.datatable_templating_demo.line_busy")}
                  </a>
                </Menu.Item>
                <hr className="m-0 p-0" />
                <Menu.Item
                  key="4"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-truck dark:!text-gray-300 ${
                    deleveryStatus === "4" ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, "4")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t(
                      "orders.datatable_templating_demo.with_delivery_company",
                    )}
                  </a>
                </Menu.Item>
                <hr className="m-0 p-0" />

                <Menu.Item
                  key="4"
                  className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-arrow-return-right dark:!text-gray-300 ${
                    deleveryStatus === "10" ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, "10")}
                >
                  <a className="s11 dark:!text-gray-300">
                    {t("orders.datatable_templating_demo.returned")}
                  </a>
                </Menu.Item>
                <hr className="m-0 p-0" />
                {/* إضافة باقي العناصر هنا */}
              </>
            )}
            <Menu.Item
              key="5"
              className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-check-circle dark:!text-gray-300 ${
                deleveryStatus === "5" ? "selected" : ""
              }`}
              onClick={() => changeStatus(rowData, "5")}
            >
              <a className="s11 dark:!text-gray-300">
                {t("orders.datatable_templating_demo.completed")}
              </a>
            </Menu.Item>

            {!shouldShowLockedContent(currentData) &&
              shippingOptions.length > 0 && (
                <>
                  <hr className="m-0 p-0" />
                  {shippingOptions.map((option) => (
                    <Menu.Item
                      key={option.value}
                      className={`rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 bi bi-truck dark:!text-gray-300 ${
                        currentData.DC === option.value ? "selected" : ""
                      }`}
                      onClick={() => {
                        changeShip(currentData, option.value);
                      }}
                    >
                      <a className="s11 dark:!text-gray-300">
                        {t(
                          "orders.datatable_templating_demo.upload_to_delivery_company",
                        )}{" "}
                        {option.label}
                      </a>
                    </Menu.Item>
                  ))}
                </>
              )}
          </Menu>
        }
      >
        <div className="relative inline-block dark:!bg-[#181919]">
          <button className="flex items-center dark:!bg-[#181919] justify-center px-3 py-2 rounded-xl border border-[#fbf4ff] dark:!border-[#3c3a3d] bg-white hover:bg-[#faf1ff] dark:hover:!bg-[#2a2a2a] shadow-sm hover:shadow-md transition duration-150 mx-auto">
            <div className="flex items-center gap-2">
              <div className="relative">
                <img
                  src={buttonImage}
                  alt={t("ui.buttonIcon")}
                  style={{ width: "18px" }}
                />
                {assignedId && (
                  <div className="absolute -top-2 -left-2">
                    {currentData?.assignedConfirmerName ? (
                      <img
                        src="/foorcall-icons.png"
                        alt={
                          currentData?.assignedConfirmerName ||
                          t("stats.confirmer")
                        }
                        className="w-5 h-5 rounded-full object-cover border-2 border-white shadow"
                      />
                    ) : confirmerPhoto ? (
                      <img
                        src={confirmerPhoto}
                        alt={
                          confirmer?.name ||
                          confirmer?.fullName ||
                          t("stats.confirmer")
                        }
                        className="w-5 h-5 rounded-full object-cover border-2 border-white shadow"
                      />
                    ) : (
                      <div className="w-5 h-5 rounded-full bg-gradient-to-br from-purple-400 to-pink-400 text-white text-[10px] font-semibold flex items-center justify-center border-2 border-white shadow">
                        {confirmerInitial}
                      </div>
                    )}
                  </div>
                )}
              </div>
              {text != null && (
                <span className="text-sm font-medium text-gray-800 dark:!text-gray-200">
                  {text}
                </span>
              )}
            </div>
          </button>

          {tentativesCount > 0 && (
            <span className="absolute -top-2 -right-2 w-5 h-5 flex items-center justify-center text-xs font-bold text-white bg-[#5a2b73] rounded-full shadow-md">
              {tentativesCount}
            </span>
          )}
        </div>
      </Dropdown>
    );
  };

  const trackship = (data) => {
    const currentData = ordersState.find((o) => o.id === data.id) || data;
    return (
      <TrackshipCell
        data={currentData}
        isLocked={shouldShowLockedContent(currentData)}
      />
    );
  };

  const shippingOptions = [];
  if (!!store.Maystro) shippingOptions.push({ value: "1", label: "Maystro" });
  if (!!store.Zrexpress)
    shippingOptions.push({ value: "2", label: "Zr express" });
  if (!!store.Ecotrack && !!store.Uecotrack)
    shippingOptions.push({ value: "3", label: "Ecotrack" });
  if (!!store.Userguid && !!store.ApitokenNord)
    shippingOptions.push({ value: "4", label: "Nord Et Ouest" });
  if (!!store.YalidineW && !!store.Yalidinetoken && !!store.Yalidineid)
    shippingOptions.push({ value: "5", label: "Yalidine" });
  if (!!store.UserguidGuepex && !!store.Apitokenguepex)
    shippingOptions.push({ value: "6", label: "Guepex" });
  if (!!store.apielogistia)
    shippingOptions.push({ value: "7", label: "elogistia" });
  if (!!store.ZimouToken)
    shippingOptions.push({ value: "8", label: "zimou Express" });
  if (!!store.AmeexId) shippingOptions.push({ value: "9", label: "Ameex" });
  if (!!store.mdm_apikey)
    shippingOptions.push({ value: "10", label: "MDM Express" });
  if (!!store.YalitecId)
    shippingOptions.push({ value: "11", label: "Yalitec" });
  if (!!store.coliv_token)
    shippingOptions.push({ value: "12", label: "Colvraison" });
  if (!!store.mylerzToken)
    shippingOptions.push({ value: "13", label: "Mylerz" });
  if (!!store.ecomdelivery_token)
    shippingOptions.push({ value: "14", label: "Ecom Delivery" });
  if (!!store.flashdelivery_key)
    shippingOptions.push({ value: "15", label: "Flash Delivery" });
  if (!!store.zrExpressXTenant_V2)
    shippingOptions.push({ value: "16", label: "Zr Express V2" });
  if (!!store.ecomdeliveryv2_key && !!store.ecomdeliveryv2_token)
    shippingOptions.push({ value: "18", label: "Ecom Delivery V2" });

  if (isDhdUser) {
    const ecotrackOnly = shippingOptions.filter((opt) => opt.value === "3");
    shippingOptions.length = 0;
    shippingOptions.push(...ecotrackOnly);
  }
  const darkModeStyles = `
  /* Styles pour le mode sombre du DataTable */
  .dark .p-datatable .p-datatable-thead > tr > th {
    background-color: #1e1e1e !important;
    color: #d1d5db !important;
    border-color: #3c3a3d !important;
    border-top: 1px solid #3c3a3d !important;
    border-bottom: 1px solid #3c3a3d !important;
    border-left: 1px solid #1e1e1e !important;
    border-right: 1px solid #1e1e1e !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr {
    background-color: #181919 !important;
    color: #d1d5db !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr:nth-child(even) {
    background-color: #1e1e1e !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr:nth-child(odd) {
    background-color: #181919 !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr > td {
    border-color: #3c3a3d !important;
    color: #d1d5db !important;
  }


  /* Pour les bordures du tableau */
  .dark .p-datatable {
    border-color: #3c3a3d !important;
  }

  /* Pour les éléments expandables */
  .dark .p-datatable .p-row-expansion {
    background-color: #141414 !important;
    color: #d1d5db !important;
  }
`;

  return (
    <div className="datatable-templating-demo">
      {/* Order Actions Toolbar */}
      <div className="bg-white dark:!bg-[#181919] rounded-t-xl p-4 border-y border-purple-100 dark:!border-[#3c3a3d]">
        <div className="flex flex-wrap items-center gap-3">
          {/* Selected Orders Label */}
          <div className="flex items-center">
            <span className="text-sm font-medium text-gray-700 ml-2 dark:text-gray-300">
              {t("orders.datatable_templating_demo.selected_orders")}:
            </span>
            <span className="bg-[#faf1ff] dark:bg-[#181919] text-[#9e68ba] px-2 py-0.5 rounded-md font-medium text-sm">
              {selectedProducts.length}
            </span>
          </div>

          {isOrderExportingEnabled &&
            linkedDeliveryCompanies.length > 0 &&
            !isDhdUser && (
              <Dropdown
                trigger={["click"]}
                disabled={selectedProducts.length < 1}
                overlay={
                  <Menu className="bg-white dark:bg-[#141414] dark:text-gray-300">
                    {linkedDeliveryCompanies.map((company) => (
                      <Menu.Item
                        key={company.key}
                        onClick={() => handleExportByCompany(company.key)}
                      >
                        {t(`shipping.${company.nameKey}`, {
                          defaultValue: company.nameKey,
                        })}
                      </Menu.Item>
                    ))}
                  </Menu>
                }
              >
                <button
                  type="button"
                  disabled={selectedProducts.length < 1}
                  className={`p-2 bg-white dark:!bg-[#141414] border rounded-lg transition-colors flex items-center gap-2 text-sm font-medium ${
                    selectedProducts.length < 1
                      ? "border-gray-200 dark:!border-[#3c3a3d] text-gray-400 opacity-50 cursor-not-allowed"
                      : "border-purple-200 dark:!border-[#3c3a3d] text-[#9e68ba] hover:bg-purple-50"
                  }`}
                >
                  <i className="pi pi-download" aria-hidden="true" />
                  {t("orders.datatable_templating_demo.export_by_company")}
                  <i className="pi pi-chevron-down" aria-hidden="true" />
                </button>
              </Dropdown>
            )}

          {/* CSV Export Button */}
          <button
            disabled={selectedProducts.length < 1 || isDhdUser}
            className={`p-2 bg-white dark:!bg-[#141414] border ${
              selectedProducts.length < 1
                ? "border-gray-200 dark:!border-[#3c3a3d] opacity-50 cursor-not-allowed"
                : "border-purple-200 dark:!border-[#3c3a3d] hover:bg-purple-50"
            } rounded-lg transition-colors flex items-center gap-2`}
          >
            <CSVLink
              data={selectedProducts.map((p) => {
                const productOptions =
                  p.products && p.products[0] && p.products[0].options;

                return {
                  index: p.index,
                  name: p.name,
                  phone: shouldShowLockedContent(p) ? "***" : p.phone,
                  state: p.state,
                  commune: p.commune,
                  address: p.address,
                  product: p.nameproduct || "منتج غير موجود",
                  qty: p.qty,
                  deleveryPrice: p.deleveryPrice,
                  total: p.total,
                  sku: p.sku,
                  options: productOptions
                    ? `Size: ${
                        productOptions.size ||
                        t("orders.datatable_templating_demo.undefined")
                      }, Color: ${
                        productOptions.color ||
                        t("orders.datatable_templating_demo.undefined")
                      }, Offer: ${
                        productOptions.offer ||
                        t("orders.datatable_templating_demo.undefined")
                      }`
                    : "لا توجد خيارات",
                };
              })}
              filename={generateFileName()}
              className={
                selectedProducts.length < 1 || isDhdUser
                  ? "pointer-events-none"
                  : ""
              }
            >
              <div className="flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className={`${
                    selectedProducts.length < 1 || isDhdUser
                      ? "text-gray-400"
                      : "text-[#9e68ba]"
                  }`}
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                <span
                  className={`${
                    selectedProducts.length < 1 || isDhdUser
                      ? "text-gray-400"
                      : "text-[#9e68ba]"
                  } text-sm font-medium`}
                >
                  {t("orders.datatable_templating_demo.export")}
                </span>
              </div>
            </CSVLink>
          </button>
          <iframe
            id="pdfPrinter"
            style={{ display: "none" }}
            title={t("ui.printPdf")}
          />

          {/* Print Button */}
          {isDhdUser ? (
            <div className="relative group">
              <button
                type="button"
                disabled={!canPrintDhd || isPrintingBordereaux}
                onClick={handlePrintDhdBordereaux}
                className={`p-2 bg-white dark:!bg-[#141414] border rounded-lg transition-colors flex items-center gap-2 ${
                  !canPrintDhd || isPrintingBordereaux
                    ? "border-gray-200 dark:!border-[#3c3a3d] opacity-50 cursor-not-allowed"
                    : "border-purple-200 dark:!border-[#3c3a3d] hover:bg-purple-50"
                }`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className={
                    !canPrintDhd || isPrintingBordereaux
                      ? "text-gray-400"
                      : "text-[#9e68ba]"
                  }
                >
                  <polyline points="6 9 6 2 18 2 18 9" />
                  <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                  <rect x="6" y="14" width="12" height="8" />
                </svg>
                <span
                  className={`text-sm font-medium ${
                    !canPrintDhd || isPrintingBordereaux
                      ? "text-gray-400"
                      : "text-[#9e68ba]"
                  }`}
                >
                  {isPrintingBordereaux
                    ? "..."
                    : t("orders.datatable_templating_demo.print")}
                </span>
              </button>

              {!canPrintDhd && selectedProducts.length > 0 && (
                <div
                  className="pointer-events-none absolute top-full left-1/2 -translate-x-1/2 mt-2 hidden group-hover:block z-50 w-56 rounded-lg bg-gray-900 text-white text-xs px-3 py-2 shadow-lg text-center"
                  role="tooltip"
                >
                  {t("orders.datatable_templating_demo.print_dhd_only_hint")}
                </div>
              )}
            </div>
          ) : (
            <button
              disabled={selectedProducts.length < 1}
              onClick={handleLabels}
              className={`p-2 bg-white border dark:!bg-[#141414] ${
                selectedProducts.length < 1
                  ? "border-gray-200 dark:!border-[#3c3a3d] opacity-50 cursor-not-allowed"
                  : "border-purple-200 dark:!border-[#3c3a3d] hover:bg-purple-50"
              } rounded-lg transition-colors flex items-center gap-2`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={`${
                  selectedProducts.length < 1
                    ? "text-gray-400"
                    : "text-[#9e68ba]"
                }`}
              >
                <polyline points="6 9 6 2 18 2 18 9" />
                <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                <rect x="6" y="14" width="12" height="8" />
              </svg>
              <span
                className={`${
                  selectedProducts.length < 1
                    ? "text-gray-400"
                    : "text-[#9e68ba]"
                } text-sm font-medium`}
              >
                {t("orders.datatable_templating_demo.print")}
              </span>
            </button>
          )}
          <GoogleSheetButtons
            selectedProducts={selectedProducts}
            t={t}
            store={store}
            showOnlyV3={true}
          />
          {/* Shipping Dropdown */}

          <div className="relative">
            {isDhdUser && shippingOptions.length === 0 ? (
              /* dhd is active but ecotrack is not configured */
              <button
                disabled
                className="p-2 bg-white dark:!bg-[#141414] border border-amber-200 dark:!border-amber-700 rounded-lg flex items-center gap-2 cursor-not-allowed"
                title={t(
                  "orders.datatable_templating_demo.activate_ecotrack_first",
                )}
              >
                <span className="text-sm text-amber-600 dark:text-amber-400 font-medium">
                  {t(
                    isDhdUser
                      ? "orders.datatable_templating_demo.activate_dhd_first"
                      : "orders.datatable_templating_demo.activate_ecotrack_first",
                  )}
                </span>
              </button>
            ) : (
              <Dropdown
                disabled={selectedProducts.length < 1 || hasValidOrders}
                overlay={
                  <Menu className="bg-white dark:bg-[#141414] rounded-lg shadow-lg border border-purple-100 dark:!border-[#3c3a3d] py-1 min-w-[200px]">
                    {shippingOptions.length > 0 && (
                      <>
                        <div>
                          <Menu>
                            {shippingOptions.map((item) => (
                              <Menu.Item
                                key={item.value}
                                className="hover:bg-purple-50 transition-colors"
                                onClick={() => {
                                  setDeleveryCompany(item.value);
                                }}
                              >
                                <a className="px-4 py-2 block text-sm text-gray-700 hover:text-[#9e68ba]">
                                  <span className="flex items-center">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="ml-2 text-[#9e68ba]"
                                    >
                                      <rect
                                        x="1"
                                        y="3"
                                        width="15"
                                        height="13"
                                      />
                                      <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
                                      <circle cx="5.5" cy="18.5" r="2.5" />
                                      <circle cx="18.5" cy="18.5" r="2.5" />
                                    </svg>
                                    {t("ui.uploadTo")} {item.label}
                                  </span>
                                </a>
                              </Menu.Item>
                            ))}
                          </Menu>
                          <Input
                            style={{ display: "none" }}
                            value={deleveryCompany}
                            onChange={(e) => setDeleveryCompany(e.target.value)}
                          />
                        </div>
                      </>
                    )}
                  </Menu>
                }
              >
                <button
                  disabled={selectedProducts.length < 1 || hasValidOrders}
                  className={`p-2 bg-white dark:!bg-[#141414]  border ${
                    selectedProducts.length < 1 || hasValidOrders
                      ? "border-gray-200 dark:!border-[#3c3a3d] opacity-50 cursor-not-allowed"
                      : "border-purple-200 dark:!border-[#3c3a3d] hover:bg-purple-50"
                  } rounded-lg transition-colors flex items-center gap-2`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={`${
                      selectedProducts.length < 1 || hasValidOrders
                        ? "text-gray-400"
                        : "text-[#9e68ba]"
                    }`}
                  >
                    <rect x="1" y="3" width="15" height="13" />
                    <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
                    <circle cx="5.5" cy="18.5" r="2.5" />
                    <circle cx="18.5" cy="18.5" r="2.5" />
                  </svg>
                  <span
                    className={`${
                      selectedProducts.length < 1 || hasValidOrders
                        ? "text-gray-400"
                        : "text-[#9e68ba]"
                    } text-sm font-medium`}
                  >
                    {t("orders.datatable_templating_demo.delivery")}
                    {hasValidOrders}
                  </span>
                </button>
              </Dropdown>
            )}
          </div>

          {/* Order Status Dropdown */}
          <select
            disabled={selectedProducts.length < 1}
            className={`p-2 bg-white border dark:!bg-[#141414] ${
              selectedProducts.length < 1
                ? "border-gray-200 opacity-50 cursor-not-allowed dark:!border-[#3c3a3d] "
                : "border-purple-200 hover:bg-purple-50 dark:!border-[#3c3a3d] dark:text-gray-300"
            } rounded-lg text-sm ${
              selectedProducts.length < 1 ? "text-gray-400" : "text-gray-700 "
            } focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent`}
            required
            value={bluck}
            onChange={(e) => {
              setBluck(e.target.value);
            }}
          >
            <option value="">
              {t("orders.datatable_templating_demo.change_order_status")}
            </option>
            <option className="dark:text-gray-300" value="3">
              {t("orders.datatable_templating_demo.confirmed")}
            </option>
            <option className="dark:text-gray-300" value="11-2">
              {t("orders.datatable_templating_demo.no_response_to_call")}
            </option>
            <option className="dark:text-gray-300" value="11-3">
              {t("orders.datatable_templating_demo.postponed")}
            </option>
            <option className="dark:text-gray-300" value="6">
              {t("orders.datatable_templating_demo.cancelled")}
            </option>
            <option className="dark:text-gray-300" value="6-1">
              {t("orders.datatable_templating_demo.fake")}
            </option>
            <option className="dark:text-gray-300" value="6-2">
              {t("orders.datatable_templating_demo.duplicate")}
            </option>
            <option className="dark:text-gray-300" value="11-5">
              {t("orders.datatable_templating_demo.cancelled_by_customer")}
            </option>
            <option className="dark:text-gray-300" value="11-1">
              {t("orders.datatable_templating_demo.awaiting_customer_contact")}
            </option>
            <option className="dark:text-gray-300" value="11-4">
              {t("orders.datatable_templating_demo.line_busy")}
            </option>
            <option className="dark:text-gray-300" value="4">
              {t("orders.datatable_templating_demo.with_delivery_company")}
            </option>
            <option className="dark:text-gray-300" value="5">
              {t("orders.datatable_templating_demo.completed")}
            </option>
            <option className="dark:text-gray-300" value="7">
              {t("orders.datatable_templating_demo.delete")}
            </option>
          </select>

          {/* Apply Button */}
          <button
            disabled={
              selectedProducts.length < 1 ||
              (bluck === "" && deleveryCompany === "")
            }
            onClick={groubeUpdates}
            className={`py-2 px-4 rounded-lg text-sm font-medium dark:!bg-[#141414] border dark:!border-[#3c3a3d] ${
              selectedProducts.length < 1 ||
              (bluck === "" && deleveryCompany === "")
                ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                : "bg-[#9b59bf] hover:bg-[#814a9f] dark:!text-[#9e68ba] text-white"
            } transition-colors`}
          >
            {t("orders.datatable_templating_demo.process_action")}
          </button>
        </div>
      </div>

      <div
        className={`dark:bg-gray-900${isDhdUser ? "select-none" : ""} `}
        onCopy={isDhdUser ? (e) => e.preventDefault() : undefined}
        onCut={isDhdUser ? (e) => e.preventDefault() : undefined}
        onContextMenu={isDhdUser ? (e) => e.preventDefault() : undefined}
        style={
          isDhdUser
            ? { userSelect: "none", WebkitUserSelect: "none" }
            : undefined
        }
      >
        <style>{darkModeStyles}</style>
        <DataTable
          value={(() => {
            let filteredData = !!filter
              ? orders.filter(
                  (order) =>
                    order.index
                      .toString()
                      .toLowerCase()
                      .includes(filter.toLowerCase()) ||
                    order.name.toLowerCase().includes(filter.toLowerCase()) ||
                    order.phone.toLowerCase().includes(filter.toLowerCase()),
                )
              : _DATA.currentData();

            // Filter by confirmer if selectedConfirmer is set and not 'all' or 'unassigned'
            if (selectedConfirmer && selectedConfirmer !== "all") {
              if (selectedConfirmer === "unassigned") {
                filteredData = filteredData.filter(
                  (order) => !order?.assignedConfirmerId,
                );
              } else {
                filteredData = filteredData.filter(
                  (order) => order?.assignedConfirmerId === selectedConfirmer,
                );
              }
            }

            return filteredData;
          })()}
          responsiveLayout="scroll"
          rowExpansionTemplate={rowExpansionTemplate}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          emptyMessage={t("ship.no_results_found")}
          rowClassName={(rowData, rowIndex) =>
            rowIndex % 2 === 0
              ? "p-row-odd dark:!bg-[#1e1e1e]"
              : "p-row-even dark:!bg-[#181919]"
          }
          className="dark:!bg-[#181919] dark:text-gray-300"
        >
          <Column
            header={
              <Form.Check
                type={"checkbox"}
                checked={selectedProducts.length === _DATA.currentData().length}
                onChange={() => {
                  selectedProducts.length === _DATA.currentData().length
                    ? setSelectedProducts([])
                    : setSelectedProducts([..._DATA.currentData()]);
                }}
                className="dark:bg-gray-700 dark:border-gray-600"
              />
            }
            className="text-end dark:!bg-[#181919] dark:!text-gray-300"
            body={selectTemplate}
            style={{ width: "3rem" }}
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
          />

          <Column
            header={t("orders.datatable_templating_demo.product")}
            className="text-end dark:!bg-[#181919] dark:!text-gray-300"
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
            body={imageBodyTemplate}
          />

          <Column
            body={customerName}
            field="name"
            className="text-end n-name dark:!bg-[#181919] dark:!text-gray-300"
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
            header={t("orders.datatable_templating_demo.customer")}
          />

          <Column
            field={notPaidTemplate}
            className="text-end n-phone dark:!bg-[#181919] dark:!text-gray-300"
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
            header={t("orders.datatable_templating_demo.phone_number")}
          />

          <Column
            body={dateBodyTemplate}
            className="text-end n-date dark:!bg-[#181919] dark:!text-gray-300"
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
            header={t("orders.datatable_templating_demo.order_date")}
          />

          <Column
            field={wilaya1}
            className="text-end n-wilaya dark:!bg-[#181919] dark:!text-gray-300"
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
            header={
              store.country === "الجزائر"
                ? t("orders.datatable_templating_demo.wilaya")
                : store.country === "مصر"
                  ? t("orders.datatable_templating_demo.wilaya_eg")
                  : t("ship.wilaya")
            }
          />

          <Column
            style={{ minwidth: "125px" }}
            header={t("orders.datatable_templating_demo.order_status")}
            className="text-end n-status1 dark:!bg-[#181919] dark:!text-gray-300"
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
            body={combinedTemplate}
          />

          {store.trackshipactive && (
            <Column
              style={{ minWidth: "125px" }}
              header={t("services.services.trackship.name")}
              className="text-end n-status1 dark:!bg-[#181919] dark:!text-gray-300"
              headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
              body={trackship}
            />
          )}

          <Column
            style={{ color: "#6e4881" }}
            body={orderTotal}
            className="text-end n-total dark:!bg-[#181919] dark:!text-gray-300"
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
            header={t("orders.datatable_templating_demo.total")}
          />

          <Column
            header=""
            className="text-end n-delet dark:!bg-[#181919] dark:!text-gray-300"
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
            body={actionTemplate}
          />

          <Column
            expander
            style={{ width: "0em" }}
            className="dark:!bg-[#181919] dark:!text-gray-300"
            headerClassName="dark:!bg-[#1e1e1e] dark:!text-gray-300"
          />
        </DataTable>
      </div>

      <div className="d-flex justify-content-center py-3 dark:!bg-[#181919]">
        {
          <Stack spacing={2} dir="ltr">
            <Pagination
              count={count}
              size="large"
              page={page}
              variant="outlined"
              shape="rounded"
              onChange={handleChange}
              color="secondary"
              sx={{
                backgroundColor: isDark ? "#181919" : "#ffffff",
                borderRadius: 2,
                p: 2,
                "& .MuiPaginationItem-root": {
                  color: isDark ? "#e1cfff" : "#000000",
                  borderColor: isDark ? "#a065c0" : "#ccc",
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: isDark ? "#9b59bf" : "#9b59bf",
                  color: "#fff",
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: isDark ? "#7c3aad" : "#f0f0f0",
                },
              }}
            />
          </Stack>
        }
      </div>
      <DeskModal
        isOpen={noestModalOpen}
        onClose={handleNoestModalClose}
        onSelect={(deskCode) => {
          setNoestSelectedDeskCode(deskCode);
          setNoestModalOpen(false);
        }}
        data={noestPendingData}
        isMultiple={isMultiple}
        onCloseMultiple={handleNoestModalClose}
        onSelectMultiple={handleNoestDeskSelected}
        apiEndpoint="https://app.noest-dz.com/api/public/desks"
        apiToken={store.ApitokenNord}
        userGuid={store.Userguid}
        companyName="Nord & Ouest"
        companyType="noest"
      />

      <DeskModal
        isOpen={yalidineModalOpen}
        onClose={handleYalidineModalClose}
        onSelect={(deskCode) => {
          setYalidineSelectedDeskCode(deskCode);
          setYalidineModalOpen(false);
        }}
        data={yalidinePendingData}
        isMultiple={isMultiple}
        onCloseMultiple={handleYalidineModalClose}
        onSelectMultiple={handleYalidineDeskSelected}
        apiEndpoint="https://backend.foorweb.shop/api/yalidine/centers"
        apiToken={store.ApitokenYalidine}
        userGuid={store.Userguid}
        companyName="Yalidine"
        companyType="yalidine"
      />

      <DeskModal
        isOpen={ecomdeliveryModalOpen}
        onClose={handleEcomdeliveryModalClose}
        onSelect={handleEcomdeliveryDeskSelected}
        data={ecomdeliveryPendingData}
        isMultiple={isMultiple}
        onCloseMultiple={handleEcomdeliveryModalClose}
        onSelectMultiple={handleEcomdeliveryDeskSelected}
        companyName="Ecom Delivery"
        companyType="ecomdelivery"
      />

      <DeskModal
        isOpen={ecomdeliveryV2ModalOpen}
        onClose={handleEcomdeliveryV2ModalClose}
        onSelect={handleEcomdeliveryV2DeskSelected}
        data={ecomdeliveryV2PendingData}
        isMultiple={isMultiple}
        onCloseMultiple={handleEcomdeliveryV2ModalClose}
        onSelectMultiple={handleEcomdeliveryV2DeskSelected}
        companyName="Ecom Delivery V2"
        companyType="ecomdelivery"
      />

      <DeskModal
        isOpen={ecotrackModalOpen}
        onClose={handleEcotrackModalClose}
        onSelect={handleEcotrackDeskSelected}
        data={ecotrackPendingData}
        desksData={ecotrackPendingDesks}
        isMultiple={isMultiple}
        onCloseMultiple={handleEcotrackModalClose}
        onSelectMultiple={handleEcotrackDeskSelected}
        companyName={
          isDhdUser && store.Uecotrack === DHD_PLATFORM_URL ? "DHD" : "Ecotrack"
        }
        companyType="ecotrack"
      />

      <DeskModal
        isOpen={zrExpressModalOpen}
        onClose={handleZrExpressModalClose}
        onSelect={handleZrExpressHubSelected}
        data={zrExpressPendingData}
        isMultiple={isMultiple}
        onCloseMultiple={handleZrExpressModalClose}
        onSelectMultiple={handleZrExpressHubSelected}
        companyName="ZR Express"
        companyType="zrexpress"
        apiEndpoint={zrHubsApiEndpoint}
        hubsHeaders={zrHubsHeaders}
        hubsSearchBody={zrHubsSearchBody}
      />

      {/* for export */}
      <DeskModal
        key={`export-ecom-desk-${exportDeskModalKey}-${exportCurrentOrder?.id || "none"}`}
        isOpen={exportDeskModalOpen}
        onClose={() => {
          if (isAdvancingExportDeskQueueRef.current) return;

          setExportDeskModalOpen(false);
          setExportDeskQueue([]);
          setExportPendingOrders(null);
          setExportCurrentOrder(null);
          exportDeskQueueRef.current = [];
          exportPendingOrdersRef.current = null;
          exportCurrentOrderRef.current = null;
          exportDeskCodesRef.current = {};
        }}
        onSelect={handleExportDeskSelected}
        data={exportCurrentOrder}
        companyType="ecomdelivery"
        companyName="Ecom Delivery"
      />

      {/* zr express export hub selection */}
      <DeskModal
        isOpen={exportZrHubModalOpen}
        onClose={() => {
          setExportDeskModalOpen(false);
          setExportDeskQueue([]);
          setExportPendingOrders(null);
          setExportCurrentOrder(null);
          exportDeskQueueRef.current = [];
          exportPendingOrdersRef.current = null;
          exportCurrentOrderRef.current = null;
          exportDeskCodesRef.current = {};
        }}
        onSelect={handleExportZrHubSelected}
        data={exportZrCurrentOrder}
        companyName="ZR Express"
        companyType="zrexpress"
        apiEndpoint={zrHubsApiEndpoint}
        hubsHeaders={zrHubsHeaders}
        hubsSearchBody={zrHubsSearchBody}
      />

      <div className="hidden">
        <ComponentToPrint
          ref={componentRef}
          data={selectedProducts}
          store={store}
          account={account}
          products={productdata}
        />
      </div>
    </div>
  );
};

export default DataTableTemplatingDemo;
